import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, TransitionGroup as _TransitionGroup, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "breadcrumb-wrap mt-1 mb-2" }
const _hoisted_4 = { "aria-label": "breadcrumb" }
const _hoisted_5 = { class: "breadcrumb mb-0" }
const _hoisted_6 = { class: "breadcrumb-item" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fa fa-home to-upper" }, null, -1)
const _hoisted_8 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_9 = {
  href: "javascript:void(0)",
  class: "breadcrumb-item active"
}
const _hoisted_10 = { class: "card" }
const _hoisted_11 = { class: "row align-items-center" }
const _hoisted_12 = { class: "col-9" }
const _hoisted_13 = { class: "title to-upper" }
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "fa fa-regular fa-thumbtack" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "fa fa-regular fa-thumbtack" }, null, -1)
const _hoisted_16 = { class: "col-3 text-right" }
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "fa fa-angle-left mr-1" }, null, -1)
const _hoisted_18 = { class: "row mx-n1" }
const _hoisted_19 = { class: "col-lg-6 px-1 order-lg-1 mb-3" }
const _hoisted_20 = { class: "card p-0 h-100" }
const _hoisted_21 = { class: "p-3" }
const _hoisted_22 = { class: "row mx-n1" }
const _hoisted_23 = { class: "col-sm-8 px-1" }
const _hoisted_24 = { class: "inline-items align-middle px-1" }
const _hoisted_25 = { class: "input-btn mb-2 mb-sm-0 my-1" }
const _hoisted_26 = /*#__PURE__*/_createVNode("i", { class: "fa fa-redo" }, null, -1)
const _hoisted_27 = { class: "col-sm-4 px-1" }
const _hoisted_28 = {
  class: "form-group control-with-icon mb-0 float-sm-right",
  id: "projectStatus"
}
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "control-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-check" })
], -1)
const _hoisted_30 = { value: "active" }
const _hoisted_31 = { value: "closed" }
const _hoisted_32 = { value: "hide" }
const _hoisted_33 = { class: "px-3" }
const _hoisted_34 = { class: "card-header-wrap p-3 mt-0" }
const _hoisted_35 = {
  class: "row align-items-center",
  id: "chatChannel"
}
const _hoisted_36 = { class: "col-lg-7 col-sm-7" }
const _hoisted_37 = { class: "card-title" }
const _hoisted_38 = /*#__PURE__*/_createVNode("i", { class: "far fa-comments text-green" }, null, -1)
const _hoisted_39 = {
  key: 0,
  class: "col-lg-5 col-sm-5 text-sm-right"
}
const _hoisted_40 = /*#__PURE__*/_createVNode("span", { class: "small-round-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" })
], -1)
const _hoisted_41 = { class: "custom-scroll vh-height" }
const _hoisted_42 = { class: "position-relative" }
const _hoisted_43 = {
  key: 0,
  class: "absolute-loader-wrap justify-content-center d-flex align-items-center"
}
const _hoisted_44 = { class: "p-2 kanban-wrap" }
const _hoisted_45 = {
  key: 0,
  class: "inner-small-wrap py-0"
}
const _hoisted_46 = { class: "chat-card-header with-actiondropdown mb-1 mb-sm-3" }
const _hoisted_47 = { class: "mb-0" }
const _hoisted_48 = /*#__PURE__*/_createVNode("span", { class: "animating-arrow" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-right" })
], -1)
const _hoisted_49 = {
  key: 0,
  class: "notification-count-wrap"
}
const _hoisted_50 = { class: "file-actions" }
const _hoisted_51 = { class: "dropdown" }
const _hoisted_52 = /*#__PURE__*/_createVNode("a", {
  class: "dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-ellipsis-h" })
], -1)
const _hoisted_53 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_54 = /*#__PURE__*/_createVNode("i", { class: "fa fa-pencil-alt mr-2" }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye mr-2" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye-slash mr-2" }, null, -1)
const _hoisted_57 = { class: "bg-light p-2 rounded mb-2 mt-sm-0 mt-2" }
const _hoisted_58 = { class: "to-upper" }
const _hoisted_59 = {
  key: 0,
  class: "active-status"
}
const _hoisted_60 = {
  key: 1,
  class: "close-status"
}
const _hoisted_61 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user-clock text-green mr-1" }, null, -1)
const _hoisted_62 = { class: "row mx-n1 align-items-center" }
const _hoisted_63 = { class: "col-sm-9 col-6 px-1" }
const _hoisted_64 = {
  key: 0,
  class: "members-list pt-0"
}
const _hoisted_65 = { key: 0 }
const _hoisted_66 = { key: 1 }
const _hoisted_67 = { class: "more-member" }
const _hoisted_68 = {
  key: 0,
  class: "col-sm-3 col-6 text-right px-1"
}
const _hoisted_69 = /*#__PURE__*/_createVNode("span", { class: "small-round-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" })
], -1)
const _hoisted_70 = { class: "channel-information channel-member-addition" }
const _hoisted_71 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_72 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user-plus" }, null, -1)
const _hoisted_73 = {
  key: 1,
  class: "mt-3 p-2"
}
const _hoisted_74 = {
  key: 0,
  id: "estimationChatChannel"
}
const _hoisted_75 = { class: "card-header-wrap p-3 mt-0" }
const _hoisted_76 = { class: "card-title" }
const _hoisted_77 = /*#__PURE__*/_createVNode("i", { class: "far fa-comments text-green" }, null, -1)
const _hoisted_78 = { class: "p-2" }
const _hoisted_79 = {
  key: 0,
  class: "inner-small-wrap"
}
const _hoisted_80 = { class: "chat-card-header" }
const _hoisted_81 = { class: "mb-0" }
const _hoisted_82 = { key: 0 }
const _hoisted_83 = /*#__PURE__*/_createTextVNode()
const _hoisted_84 = /*#__PURE__*/_createVNode("span", { class: "animating-arrow" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-right" })
], -1)
const _hoisted_85 = { class: "bg-white p-2 rounded mb-2" }
const _hoisted_86 = { class: "channel-information" }
const _hoisted_87 = { class: "inline-list" }
const _hoisted_88 = { class: "pl-0 pr-2 mr-0" }
const _hoisted_89 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user" }, null, -1)
const _hoisted_90 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user" }, null, -1)
const _hoisted_91 = {
  key: 2,
  href: "javascript:void(0)"
}
const _hoisted_92 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user" }, null, -1)
const _hoisted_93 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_94 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user-plus" }, null, -1)
const _hoisted_95 = /*#__PURE__*/_createVNode("i", { class: "fas fa-clock text-green" }, null, -1)
const _hoisted_96 = {
  key: 1,
  id: "privateChatChannel"
}
const _hoisted_97 = { class: "card-header-wrap p-3 mt-0" }
const _hoisted_98 = { class: "card-title" }
const _hoisted_99 = /*#__PURE__*/_createVNode("i", { class: "fa fa-lock text-green" }, null, -1)
const _hoisted_100 = { class: "p-2" }
const _hoisted_101 = {
  key: 0,
  class: "inner-small-wrap"
}
const _hoisted_102 = { class: "chat-card-header" }
const _hoisted_103 = { class: "mb-0" }
const _hoisted_104 = /*#__PURE__*/_createVNode("span", { class: "animating-arrow" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-right" })
], -1)
const _hoisted_105 = { key: 0 }
const _hoisted_106 = {
  key: 0,
  class: "file-actions"
}
const _hoisted_107 = { class: "dropdown" }
const _hoisted_108 = /*#__PURE__*/_createVNode("a", {
  class: "dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-ellipsis-h" })
], -1)
const _hoisted_109 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_110 = /*#__PURE__*/_createVNode("i", { class: "fa fa-pencil-alt mr-2" }, null, -1)
const _hoisted_111 = { class: "bg-white p-2 rounded mb-2" }
const _hoisted_112 = { class: "mb-0" }
const _hoisted_113 = { class: "row mx-n1 align-items-center" }
const _hoisted_114 = { class: "col-sm-9 col-6 px-1" }
const _hoisted_115 = {
  key: 0,
  class: "members-list pt-0"
}
const _hoisted_116 = { key: 0 }
const _hoisted_117 = { key: 1 }
const _hoisted_118 = { class: "more-member" }
const _hoisted_119 = { class: "col-sm-3 col-6 text-right px-1" }
const _hoisted_120 = /*#__PURE__*/_createVNode("span", { class: "small-round-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" })
], -1)
const _hoisted_121 = { class: "channel-information" }
const _hoisted_122 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_123 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user-plus" }, null, -1)
const _hoisted_124 = /*#__PURE__*/_createVNode("i", { class: "fas fa-clock text-green" }, null, -1)
const _hoisted_125 = {
  key: 2,
  id: "approvalChatChannel"
}
const _hoisted_126 = { class: "card-header-wrap p-3 mt-0" }
const _hoisted_127 = { class: "card-title" }
const _hoisted_128 = /*#__PURE__*/_createVNode("i", { class: "far fa-comments text-green" }, null, -1)
const _hoisted_129 = { class: "p-2" }
const _hoisted_130 = {
  key: 0,
  class: "inner-small-wrap"
}
const _hoisted_131 = { class: "chat-card-header" }
const _hoisted_132 = { class: "mb-0" }
const _hoisted_133 = /*#__PURE__*/_createVNode("span", { class: "animating-arrow" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-right" })
], -1)
const _hoisted_134 = { key: 0 }
const _hoisted_135 = { class: "bg-white p-2 rounded mb-2" }
const _hoisted_136 = { class: "channel-information" }
const _hoisted_137 = { class: "inline-list" }
const _hoisted_138 = { class: "pl-0 pr-2 mr-0" }
const _hoisted_139 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user" }, null, -1)
const _hoisted_140 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user" }, null, -1)
const _hoisted_141 = {
  key: 2,
  href: "javascript:void(0)"
}
const _hoisted_142 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user" }, null, -1)
const _hoisted_143 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_144 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user-plus" }, null, -1)
const _hoisted_145 = /*#__PURE__*/_createVNode("i", { class: "fas fa-clock text-green" }, null, -1)
const _hoisted_146 = {
  key: 3,
  id: "phaseChatChannel"
}
const _hoisted_147 = { class: "card-header-wrap p-3 mt-0" }
const _hoisted_148 = { class: "card-title" }
const _hoisted_149 = /*#__PURE__*/_createVNode("i", { class: "far fa-comments text-green" }, null, -1)
const _hoisted_150 = { class: "p-2" }
const _hoisted_151 = {
  key: 0,
  class: "inner-small-wrap"
}
const _hoisted_152 = { class: "chat-card-header" }
const _hoisted_153 = { class: "mb-0" }
const _hoisted_154 = /*#__PURE__*/_createVNode("span", { class: "animating-arrow" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-right" })
], -1)
const _hoisted_155 = { key: 0 }
const _hoisted_156 = { class: "bg-white p-2 rounded mb-2" }
const _hoisted_157 = { class: "channel-information" }
const _hoisted_158 = { class: "inline-list" }
const _hoisted_159 = { class: "pl-0 pr-2 mr-0" }
const _hoisted_160 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user" }, null, -1)
const _hoisted_161 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user" }, null, -1)
const _hoisted_162 = {
  key: 2,
  href: "javascript:void(0)"
}
const _hoisted_163 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user" }, null, -1)
const _hoisted_164 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_165 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user-plus" }, null, -1)
const _hoisted_166 = /*#__PURE__*/_createVNode("i", { class: "fas fa-clock text-green" }, null, -1)
const _hoisted_167 = { class: "col-lg-3 px-1 order-lg-1 mb-3" }
const _hoisted_168 = { class: "bordered-tab-wrap card p-0 h-100" }
const _hoisted_169 = {
  class: "nav nav-tabs",
  id: "myTab1",
  role: "tablist"
}
const _hoisted_170 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_171 = {
  class: "nav-link active",
  id: "todo-tab",
  "data-toggle": "tab",
  "data-target": "#todo",
  type: "button",
  role: "tab",
  "aria-controls": "todo",
  "aria-selected": "true"
}
const _hoisted_172 = /*#__PURE__*/_createVNode("span", { class: "tab-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-clipboard-list" })
], -1)
const _hoisted_173 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_174 = {
  class: "nav-link",
  id: "forms-tab",
  "data-toggle": "tab",
  "data-target": "#forms",
  type: "button",
  role: "tab",
  "aria-controls": "forms",
  "aria-selected": "false"
}
const _hoisted_175 = /*#__PURE__*/_createVNode("span", { class: "tab-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-copy" })
], -1)
const _hoisted_176 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_177 = {
  class: "nav-link",
  id: "sharemembers-tab",
  "data-toggle": "tab",
  "data-target": "#sharemembers",
  type: "button",
  role: "tab",
  "aria-controls": "sharemembers",
  "aria-selected": "false"
}
const _hoisted_178 = /*#__PURE__*/_createVNode("span", { class: "tab-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-share-alt" })
], -1)
const _hoisted_179 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_180 = {
  class: "tab-pane px-0 fade show active",
  id: "todo",
  role: "tabpanel",
  "aria-labelledby": "todo-tab"
}
const _hoisted_181 = { id: "todo" }
const _hoisted_182 = {
  key: 0,
  class: "p-2",
  id: "addChannelMember"
}
const _hoisted_183 = { class: "inline-items align-middle" }
const _hoisted_184 = { key: 0 }
const _hoisted_185 = { key: 1 }
const _hoisted_186 = { key: 2 }
const _hoisted_187 = { key: 3 }
const _hoisted_188 = { key: 4 }
const _hoisted_189 = /*#__PURE__*/_createVNode("i", { class: "fas fa-envelope-open-text" }, null, -1)
const _hoisted_190 = {
  key: 0,
  id: "todoInvitations"
}
const _hoisted_191 = { class: "member-heading my-2 px-2" }
const _hoisted_192 = { class: "card-title card-title mb-lg-0" }
const _hoisted_193 = { class: "table-wrap" }
const _hoisted_194 = { class: "table-responsive" }
const _hoisted_195 = { class: "table table-borderless mb-0 font-12" }
const _hoisted_196 = { class: "table-light text-nowrap" }
const _hoisted_197 = { key: 0 }
const _hoisted_198 = { class: "phase-row" }
const _hoisted_199 = { key: 1 }
const _hoisted_200 = { class: "phase-row" }
const _hoisted_201 = { key: 2 }
const _hoisted_202 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" }, null, -1)
const _hoisted_203 = { key: 3 }
const _hoisted_204 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" }, null, -1)
const _hoisted_205 = { class: "align-items-center mt-2 justify-content-between d-flex" }
const _hoisted_206 = {
  key: 0,
  class: "flex-shrink-0"
}
const _hoisted_207 = { class: "text-muted px-2" }
const _hoisted_208 = {
  key: 0,
  class: "fw-semibold"
}
const _hoisted_209 = {
  key: 1,
  class: "fw-semibold"
}
const _hoisted_210 = {
  class: "tab-pane px-0 fade",
  id: "forms",
  role: "tabpanel",
  "aria-labelledby": "forms-tab"
}
const _hoisted_211 = { id: "latestForms" }
const _hoisted_212 = {
  class: "my-2 px-2",
  id: "latestFormsSearch"
}
const _hoisted_213 = { class: "input-btn" }
const _hoisted_214 = /*#__PURE__*/_createVNode("a", {
  href: "javascript:void(0)",
  class: "btn default-btn px-1"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-search" })
], -1)
const _hoisted_215 = {
  key: 0,
  class: "p-2"
}
const _hoisted_216 = { class: "see-all  px-2" }
const _hoisted_217 = { href: "javascript:void(0)" }
const _hoisted_218 = /*#__PURE__*/_createTextVNode("View all forms ")
const _hoisted_219 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-right" }, null, -1)
const _hoisted_220 = { key: 1 }
const _hoisted_221 = {
  class: "tab-pane px-0 fade",
  id: "sharemembers",
  role: "tabpanel",
  "aria-labelledby": "sharemembers-tab"
}
const _hoisted_222 = {
  key: 0,
  id: "membersActivity"
}
const _hoisted_223 = {
  class: "p-2",
  id: "addChannelMember"
}
const _hoisted_224 = /*#__PURE__*/_createVNode("i", { class: "fa fa-user-plus" }, null, -1)
const _hoisted_225 = { key: 0 }
const _hoisted_226 = { class: "table-responsive" }
const _hoisted_227 = { class: "table table-borderless mb-0 font-12" }
const _hoisted_228 = { class: "table-light text-nowrap" }
const _hoisted_229 = { class: "to-upper" }
const _hoisted_230 = { class: "to-upper" }
const _hoisted_231 = { class: "email-row" }
const _hoisted_232 = {
  href: "javascript:void(0)",
  class: "link-primary"
}
const _hoisted_233 = {
  key: 0,
  class: "badge badge-soft-warning"
}
const _hoisted_234 = {
  key: 1,
  class: "badge badge-dim badge-info ml-1"
}
const _hoisted_235 = {
  key: 2,
  class: "badge badge-dim badge-light text-gray ml-1"
}
const _hoisted_236 = {
  key: 3,
  class: "badge badge-dim badge-success ml-1"
}
const _hoisted_237 = { class: "file-actions position-relative" }
const _hoisted_238 = { class: "dropdown" }
const _hoisted_239 = /*#__PURE__*/_createVNode("a", {
  class: "dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-ellipsis-v" })
], -1)
const _hoisted_240 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_241 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye mr-2" }, null, -1)
const _hoisted_242 = /*#__PURE__*/_createVNode("i", { class: "fa fa-pen mr-2" }, null, -1)
const _hoisted_243 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash mr-2" }, null, -1)
const _hoisted_244 = {
  key: 1,
  class: "mt-3  px-2"
}
const _hoisted_245 = { class: "col-lg-3 px-1 order-lg-0 mb-3" }
const _hoisted_246 = { class: "bordered-tab-wrap card p-0 h-100" }
const _hoisted_247 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_248 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_249 = {
  class: "nav-link active",
  id: "members-tab",
  "data-toggle": "tab",
  "data-target": "#members",
  type: "button",
  role: "tab",
  "aria-controls": "members",
  "aria-selected": "true"
}
const _hoisted_250 = /*#__PURE__*/_createVNode("span", { class: "tab-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-user-friends" })
], -1)
const _hoisted_251 = { key: 0 }
const _hoisted_252 = { key: 1 }
const _hoisted_253 = { key: 2 }
const _hoisted_254 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_255 = {
  class: "nav-link",
  id: "history-tab",
  "data-toggle": "tab",
  "data-target": "#history",
  type: "button",
  role: "tab",
  "aria-controls": "history",
  "aria-selected": "false"
}
const _hoisted_256 = /*#__PURE__*/_createVNode("span", { class: "tab-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-history" })
], -1)
const _hoisted_257 = { class: "tab-content" }
const _hoisted_258 = {
  class: "tab-pane",
  id: "history",
  role: "tabpanel",
  "aria-labelledby": "home-tab"
}
const _hoisted_259 = { class: "custom-scroll fixed-ht-500" }
const _hoisted_260 = { class: "inner-small-wrap pb-0" }
const _hoisted_261 = {
  key: 0,
  class: "activity-block"
}
const _hoisted_262 = { key: 1 }
const _hoisted_263 = {
  class: "tab-pane active",
  id: "members",
  role: "tabpanel",
  "aria-labelledby": "members-tab"
}
const _hoisted_264 = { id: "membersActivity" }
const _hoisted_265 = { class: "card-head pb-3 py-2" }
const _hoisted_266 = { class: "inline-items" }
const _hoisted_267 = { id: "addChannelMember" }
const _hoisted_268 = /*#__PURE__*/_createVNode("i", { class: "fa fa-user-plus" }, null, -1)
const _hoisted_269 = { id: "addChannelMember" }
const _hoisted_270 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_271 = { key: 0 }
const _hoisted_272 = { class: "member-heading mb-0" }
const _hoisted_273 = {
  href: "javascript:void(0)",
  class: "text-warning",
  "data-toggle": "modal",
  "data-target": "#pendingMembers"
}
const _hoisted_274 = {
  key: 0,
  class: "custom-scroll fixed-ht-500"
}
const _hoisted_275 = {
  key: 0,
  class: "member-fig"
}
const _hoisted_276 = { key: 1 }
const _hoisted_277 = { class: "role-type type-owner" }
const _hoisted_278 = { key: 2 }
const _hoisted_279 = {
  key: 3,
  class: "time"
}
const _hoisted_280 = /*#__PURE__*/_createVNode("i", { class: "far fa-clock" }, null, -1)
const _hoisted_281 = { class: "my-2" }
const _hoisted_282 = /*#__PURE__*/_createVNode("i", { class: "far fa-paper-plane" }, null, -1)
const _hoisted_283 = /*#__PURE__*/_createVNode("i", { class: "fas fa-random" }, null, -1)
const _hoisted_284 = {
  key: 2,
  class: "remove-btn"
}
const _hoisted_285 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_286 = { key: 1 }
const _hoisted_287 = {
  key: 0,
  class: "member-fig"
}
const _hoisted_288 = { key: 1 }
const _hoisted_289 = {
  key: 2,
  class: "time"
}
const _hoisted_290 = /*#__PURE__*/_createVNode("i", { class: "far fa-clock" }, null, -1)
const _hoisted_291 = { class: "change-role" }
const _hoisted_292 = /*#__PURE__*/_createVNode("i", { class: "fas fa-random" }, null, -1)
const _hoisted_293 = {
  key: 3,
  class: "remove-btn"
}
const _hoisted_294 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_295 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_296 = { class: "modal-wrap default-modal" }
const _hoisted_297 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "createChannelByProject",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_298 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_299 = { class: "modal-content" }
const _hoisted_300 = { class: "modal-header" }
const _hoisted_301 = { class: "d-block" }
const _hoisted_302 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_303 = { class: "text-muted" }
const _hoisted_304 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_305 = { class: "modal-body" }
const _hoisted_306 = { class: "form-group" }
const _hoisted_307 = { for: "exampleInputEmail1" }
const _hoisted_308 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "*", -1)
const _hoisted_309 = { class: "form-group" }
const _hoisted_310 = { for: "exampleInputEmail1" }
const _hoisted_311 = { class: "modal-footer" }
const _hoisted_312 = { class: "modal-wrap" }
const _hoisted_313 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "sendTo",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_314 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_315 = { class: "modal-content" }
const _hoisted_316 = { class: "modal-header" }
const _hoisted_317 = { class: "d-block" }
const _hoisted_318 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_319 = { class: "text-muted" }
const _hoisted_320 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_321 = { class: "modal-body" }
const _hoisted_322 = { class: "form-group" }
const _hoisted_323 = { for: "exampleInputEmail1" }
const _hoisted_324 = { class: "form-group mb-0" }
const _hoisted_325 = { for: "exampleInputEmail1" }
const _hoisted_326 = { class: "modal-footer" }
const _hoisted_327 = {
  type: "button",
  class: "btn default-btn"
}
const _hoisted_328 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_329 = {
  class: "modal fade default-modal",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "inviteMember",
  tabindex: "-1",
  "aria-labelledby": "inviteMember",
  "aria-hidden": "true"
}
const _hoisted_330 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_331 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_332 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_333 = { class: "modal-content" }
const _hoisted_334 = { class: "modal-header" }
const _hoisted_335 = { class: "d-block" }
const _hoisted_336 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_337 = { class: "text-muted" }
const _hoisted_338 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_339 = { class: "modal-body" }
const _hoisted_340 = { class: "form-group pt-0" }
const _hoisted_341 = { key: 0 }
const _hoisted_342 = { class: "inline-items" }
const _hoisted_343 = {
  key: 0,
  class: "form-group"
}
const _hoisted_344 = { class: "custom-control custom-switch mr-3" }
const _hoisted_345 = {
  class: "custom-control-label",
  for: "guestSwitch"
}
const _hoisted_346 = {
  key: 0,
  class: "from-group"
}
const _hoisted_347 = { class: "custom-control custom-switch mr-3" }
const _hoisted_348 = {
  class: "custom-control-label",
  for: "guestSwitch1"
}
const _hoisted_349 = {
  key: 0,
  class: "form-group"
}
const _hoisted_350 = { for: "exampleInputEmail1" }
const _hoisted_351 = { class: "mb-0" }
const _hoisted_352 = {
  key: 0,
  class: "fa fa-trash-alt"
}
const _hoisted_353 = {
  key: 1,
  class: "alert alert-danger text-center",
  role: "alert"
}
const _hoisted_354 = { class: "mb-0" }
const _hoisted_355 = { class: "mb-0" }
const _hoisted_356 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_357 = {
  key: 2,
  class: "form-group"
}
const _hoisted_358 = { for: "exampleInputEmail1" }
const _hoisted_359 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_360 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_361 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_362 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_363 = {
  key: 2,
  class: "mb-0"
}
const _hoisted_364 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_365 = {
  key: 3,
  class: "form-group"
}
const _hoisted_366 = { for: "exampleInputEmail1" }
const _hoisted_367 = { key: 0 }
const _hoisted_368 = { key: 1 }
const _hoisted_369 = {
  key: 2,
  class: "table-wrap table-responsive mb-3"
}
const _hoisted_370 = { class: "table table-bordered table-shadowed font-12" }
const _hoisted_371 = { class: "table-primary nowrap-text" }
const _hoisted_372 = { class: "form-group" }
const _hoisted_373 = { class: "form-group" }
const _hoisted_374 = { class: "form-group" }
const _hoisted_375 = { class: "input-group" }
const _hoisted_376 = { class: "form-group" }
const _hoisted_377 = { class: "form-group" }
const _hoisted_378 = {
  class: "notify-by-form-group",
  id: "notifyByFormGroup"
}
const _hoisted_379 = { class: "form-check form-check-inline" }
const _hoisted_380 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "inlineCheckbox1"
}, "Email", -1)
const _hoisted_381 = { class: "form-check form-check-inline" }
const _hoisted_382 = {
  class: "form-check-label",
  for: "inlineCheckbox2"
}
const _hoisted_383 = { class: "text-nowrap" }
const _hoisted_384 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_385 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_386 = { class: "modal-title" }
const _hoisted_387 = { class: "text-muted" }
const _hoisted_388 = { class: "form-group mt-3" }
const _hoisted_389 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_390 = {
  class: "custom-control-label",
  for: "customRadioInline1"
}
const _hoisted_391 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_392 = {
  class: "custom-control-label",
  for: "customRadioInline2"
}
const _hoisted_393 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_394 = {
  class: "custom-control-label",
  for: "customRadioInline3"
}
const _hoisted_395 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_396 = {
  class: "custom-control-label",
  for: "customRadioInline4"
}
const _hoisted_397 = {
  key: 3,
  class: "row"
}
const _hoisted_398 = { class: "col-md-3" }
const _hoisted_399 = { class: "form-group" }
const _hoisted_400 = {
  key: 4,
  class: "alert alert-warning text-center",
  role: "alert"
}
const _hoisted_401 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle me-1" }, null, -1)
const _hoisted_402 = /*#__PURE__*/_createTextVNode(" There are some errors, Please check above. ")
const _hoisted_403 = {
  key: 4,
  class: "form-group"
}
const _hoisted_404 = { for: "exampleInputEmail1" }
const _hoisted_405 = { class: "col-lg-2" }
const _hoisted_406 = { class: "form-group" }
const _hoisted_407 = { for: "exampleFullName" }
const _hoisted_408 = { class: "col-lg-3" }
const _hoisted_409 = { class: "form-group" }
const _hoisted_410 = { for: "exampleEmailInput" }
const _hoisted_411 = { class: "col-lg-3" }
const _hoisted_412 = { class: "form-group" }
const _hoisted_413 = { for: "exampleMobileNumber" }
const _hoisted_414 = { class: "input-group" }
const _hoisted_415 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("span", { class: "input-group-text" }, "+1")
], -1)
const _hoisted_416 = { class: "col-lg-2" }
const _hoisted_417 = { for: "notifyByFormGroup" }
const _hoisted_418 = {
  class: "notify-by-form-group",
  id: "notifyByFormGroup"
}
const _hoisted_419 = { class: "form-check form-check-inline" }
const _hoisted_420 = {
  class: "form-check-label",
  for: "inlineCheckbox1"
}
const _hoisted_421 = { class: "form-check form-check-inline" }
const _hoisted_422 = {
  class: "form-check-label",
  for: "inlineCheckbox2"
}
const _hoisted_423 = { class: "col-lg-2" }
const _hoisted_424 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_425 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_426 = { class: "mb-0" }
const _hoisted_427 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_428 = { class: "modal-footer" }
const _hoisted_429 = { class: "modal-wrap default-modal" }
const _hoisted_430 = {
  class: "modal fade default-modal",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "addShareProject",
  tabindex: "-1",
  "aria-labelledby": "addShareProject",
  "aria-hidden": "true"
}
const _hoisted_431 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_432 = { class: "modal-content" }
const _hoisted_433 = { class: "modal-header" }
const _hoisted_434 = { class: "d-block" }
const _hoisted_435 = {
  class: "modal-title",
  id: "addShareProject"
}
const _hoisted_436 = { class: "text-muted" }
const _hoisted_437 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_438 = { class: "modal-body" }
const _hoisted_439 = { class: "pt-0" }
const _hoisted_440 = { key: 0 }
const _hoisted_441 = { class: "form-group" }
const _hoisted_442 = { for: "exampleInputEmail1" }
const _hoisted_443 = { disabled: "" }
const _hoisted_444 = { class: "mb-0" }
const _hoisted_445 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_446 = { class: "form-group" }
const _hoisted_447 = { for: "exampleInputEmail1" }
const _hoisted_448 = { class: "input-btn" }
const _hoisted_449 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_450 = { class: "mb-0" }
const _hoisted_451 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_452 = { class: "form-group" }
const _hoisted_453 = { for: "exampleInputEmail1" }
const _hoisted_454 = { class: "form-group" }
const _hoisted_455 = { class: "form-check form-check-inline" }
const _hoisted_456 = {
  class: "form-check-label",
  for: "inlineCheckbox2"
}
const _hoisted_457 = { key: 1 }
const _hoisted_458 = {
  key: 0,
  class: "form-group"
}
const _hoisted_459 = {
  class: "alert alert-success text-center mb-0",
  role: "alert"
}
const _hoisted_460 = { class: "block-element" }
const _hoisted_461 = {
  key: 1,
  class: "form-group"
}
const _hoisted_462 = {
  class: "alert alert-success text-center mb-0",
  role: "alert"
}
const _hoisted_463 = { class: "text-danger" }
const _hoisted_464 = { class: "block-element" }
const _hoisted_465 = {
  key: 2,
  class: "form-group"
}
const _hoisted_466 = {
  class: "alert alert-success text-center mb-0",
  role: "alert"
}
const _hoisted_467 = { class: "block-element" }
const _hoisted_468 = { class: "my-2" }
const _hoisted_469 = /*#__PURE__*/_createVNode("i", { class: "fa fa-user-check" }, null, -1)
const _hoisted_470 = /*#__PURE__*/_createTextVNode()
const _hoisted_471 = { key: 0 }
const _hoisted_472 = { class: "text-success to-upper" }
const _hoisted_473 = { key: 1 }
const _hoisted_474 = { class: "text-danger" }
const _hoisted_475 = /*#__PURE__*/_createTextVNode()
const _hoisted_476 = { key: 2 }
const _hoisted_477 = { class: "text-primary" }
const _hoisted_478 = /*#__PURE__*/_createTextVNode()
const _hoisted_479 = { class: "modal-footer" }
const _hoisted_480 = { key: 1 }
const _hoisted_481 = { class: "modal-wrap default-modal" }
const _hoisted_482 = {
  class: "modal fade default-modal",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "editShareProject",
  tabindex: "-1",
  "aria-labelledby": "editShareProject",
  "aria-hidden": "true"
}
const _hoisted_483 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_484 = {
  key: 0,
  class: "table-loader chat-load"
}
const _hoisted_485 = {
  key: 1,
  class: "modal-content"
}
const _hoisted_486 = { class: "modal-header" }
const _hoisted_487 = { class: "d-block" }
const _hoisted_488 = {
  class: "modal-title",
  id: "editShareProject"
}
const _hoisted_489 = { class: "text-muted" }
const _hoisted_490 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_491 = { class: "modal-body" }
const _hoisted_492 = { class: "pt-0" }
const _hoisted_493 = { class: "form-group" }
const _hoisted_494 = { for: "exampleInputEmail1" }
const _hoisted_495 = { class: "email-tag" }
const _hoisted_496 = { class: "mb-0" }
const _hoisted_497 = {
  key: 0,
  class: "form-group"
}
const _hoisted_498 = { for: "exampleInputEmail1" }
const _hoisted_499 = {
  key: 1,
  class: "form-group"
}
const _hoisted_500 = { for: "exampleInputEmail1" }
const _hoisted_501 = { class: "form-group" }
const _hoisted_502 = { class: "form-check form-check-inline" }
const _hoisted_503 = {
  class: "form-check-label",
  for: "inlineCheckbox2"
}
const _hoisted_504 = { class: "modal-footer" }
const _hoisted_505 = { key: 1 }
const _hoisted_506 = { class: "modal-wrap default-modal" }
const _hoisted_507 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "successModal",
  tabindex: "-1",
  "aria-labelledby": "inviteMember",
  "aria-hidden": "true"
}
const _hoisted_508 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_509 = { class: "modal-content text-center" }
const _hoisted_510 = { class: "msg-header" }
const _hoisted_511 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_512 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    class: "bi bi-check-circle",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"
    })
  ])
], -1)
const _hoisted_513 = { class: "msg-body" }
const _hoisted_514 = { class: "msg-footer" }
const _hoisted_515 = { class: "modal-wrap default-modal" }
const _hoisted_516 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "successProjectShareInvitationModal",
  tabindex: "-1",
  "aria-labelledby": "successProjectShareInvitationModal",
  "aria-hidden": "true"
}
const _hoisted_517 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_518 = { class: "modal-content text-center" }
const _hoisted_519 = { class: "msg-header" }
const _hoisted_520 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_521 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    class: "bi bi-check-circle",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"
    })
  ])
], -1)
const _hoisted_522 = { class: "msg-body" }
const _hoisted_523 = { class: "msg-footer" }
const _hoisted_524 = { class: "modal-wrap default-modal" }
const _hoisted_525 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "projectAcknowledgementRequestDetails",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_526 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_527 = { class: "modal-content" }
const _hoisted_528 = { class: "modal-header" }
const _hoisted_529 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_530 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_531 = { class: "modal-body" }
const _hoisted_532 = { class: "pt-0" }
const _hoisted_533 = { class: "form-group" }
const _hoisted_534 = {
  key: 0,
  class: "row"
}
const _hoisted_535 = { class: "col-md-3" }
const _hoisted_536 = { class: "col-md-9" }
const _hoisted_537 = { class: "payer-email-list-display" }
const _hoisted_538 = { key: 0 }
const _hoisted_539 = { key: 1 }
const _hoisted_540 = { class: "form-group" }
const _hoisted_541 = { class: "mb-0 mt-3" }
const _hoisted_542 = { key: 0 }
const _hoisted_543 = { class: "form-group" }
const _hoisted_544 = { class: "form-group" }
const _hoisted_545 = { class: "mb-0 mt-3" }
const _hoisted_546 = { key: 0 }
const _hoisted_547 = { class: "form-group" }
const _hoisted_548 = { class: "mb-0 mt-3 to-upper" }
const _hoisted_549 = {
  key: 0,
  class: "table-wrap"
}
const _hoisted_550 = { class: "table-responsive mt-3" }
const _hoisted_551 = { class: "table table-bordered mb-0" }
const _hoisted_552 = { class: "text-muted table-light" }
const _hoisted_553 = { class: "to-upper" }
const _hoisted_554 = {
  href: "javascript:void(0)",
  class: "link-primary"
}
const _hoisted_555 = { class: "modal-footer" }
const _hoisted_556 = { class: "modal-wrap default-modal" }
const _hoisted_557 = {
  class: "modal fade bd-example-modal-sm",
  id: "pendingMembers",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLongTitle",
  "aria-hidden": "true",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_558 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_559 = { class: "modal-content" }
const _hoisted_560 = { class: "modal-header" }
const _hoisted_561 = {
  class: "modal-title",
  id: "exampleModalLongTitle"
}
const _hoisted_562 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_563 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_564 = { class: "col-md-8" }
const _hoisted_565 = { class: "member-list mb-1 pr-0" }
const _hoisted_566 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("img", {
    src: "https://dummyimage.com/50x50/b5b5b5/ffffff",
    alt: ""
  })
], -1)
const _hoisted_567 = { class: "text-lowercase" }
const _hoisted_568 = { class: "col-md-4 text-md-right" }
const _hoisted_569 = {
  class: "btn default-btn outline p-1",
  href: "#"
}
const _hoisted_570 = /*#__PURE__*/_createVNode("i", { class: "fa fa-share" }, null, -1)
const _hoisted_571 = {
  key: 1,
  class: "inner-wrap"
}
const _hoisted_572 = { class: "modal-footer" }
const _hoisted_573 = {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}
const _hoisted_574 = { class: "modal-wrap default-modal md-size" }
const _hoisted_575 = {
  class: "modal fade",
  id: "userprofile",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_576 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_577 = { class: "modal-content" }
const _hoisted_578 = { class: "modal-header" }
const _hoisted_579 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_580 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_581 = { class: "modal-body" }
const _hoisted_582 = {
  key: 0,
  class: "member-list mb-2"
}
const _hoisted_583 = {
  key: 0,
  class: "member-fig"
}
const _hoisted_584 = {
  key: 1,
  class: "member-fig"
}
const _hoisted_585 = /*#__PURE__*/_createVNode("img", {
  src: "https://dummyimage.com/80x80/000/fff",
  alt: "",
  class: "img-circle"
}, null, -1)
const _hoisted_586 = { key: 2 }
const _hoisted_587 = {
  key: 3,
  class: "mb-0"
}
const _hoisted_588 = /*#__PURE__*/_createVNode("i", { class: "fas fa-envelope" }, null, -1)
const _hoisted_589 = { class: "user-body" }
const _hoisted_590 = {
  key: 0,
  class: "text-muted mb-3"
}
const _hoisted_591 = {
  key: 1,
  class: "form-group"
}
const _hoisted_592 = { for: "inputState" }
const _hoisted_593 = {
  key: 2,
  class: "form-group bg-light border p-3 rounded"
}
const _hoisted_594 = {
  class: "mb-0",
  for: ""
}
const _hoisted_595 = /*#__PURE__*/_createVNode("i", {
  title: "The given members belongs to the channel with a tick but not the channel without a tick.",
  class: "fa fa-info-circle text-green"
}, null, -1)
const _hoisted_596 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_597 = { class: "inline-items" }
const _hoisted_598 = { class: "custom-control custom-checkbox mb-3" }
const _hoisted_599 = {
  key: 3,
  class: "form-group"
}
const _hoisted_600 = { for: "inputState" }
const _hoisted_601 = { class: "input-group" }
const _hoisted_602 = /*#__PURE__*/_createVNode("i", { class: "far fa-calendar-alt" }, null, -1)
const _hoisted_603 = {
  key: 1,
  class: "user-footer border-top pt-3"
}
const _hoisted_604 = { class: "modal-wrap remove-user-modal default-modal" }
const _hoisted_605 = {
  class: "modal fade",
  id: "removemember",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_606 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_607 = {
  key: 0,
  class: "modal-content h-auto"
}
const _hoisted_608 = { class: "modal-header" }
const _hoisted_609 = {
  key: 0,
  class: "modal-title to-upper",
  id: "exampleModalLabel"
}
const _hoisted_610 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_611 = { class: "modal-body" }
const _hoisted_612 = { class: "block-list" }
const _hoisted_613 = { key: 0 }
const _hoisted_614 = { key: 1 }
const _hoisted_615 = { class: "modal-footer" }
const _hoisted_616 = { class: "modal-wrap default-modal" }
const _hoisted_617 = {
  class: "modal fade",
  id: "memberModal",
  tabindex: "-1",
  "aria-labelledby": "memberModalLabel",
  "aria-hidden": "true"
}
const _hoisted_618 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_619 = { class: "modal-content" }
const _hoisted_620 = { class: "modal-header" }
const _hoisted_621 = {
  class: "modal-title",
  id: "memberModalLabel"
}
const _hoisted_622 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_623 = {
  key: 0,
  class: "member-list pr-0"
}
const _hoisted_624 = { class: "round-img" }
const _hoisted_625 = {
  key: 0,
  class: "text-lowercase"
}
const _hoisted_626 = {
  key: 1,
  class: "member-list pr-0"
}
const _hoisted_627 = { class: "round-img" }
const _hoisted_628 = {
  key: 0,
  class: "text-lowercase"
}
const _hoisted_629 = { class: "modal-footer" }
const _hoisted_630 = { class: "modal-wrap default-modal" }
const _hoisted_631 = {
  class: "modal fade",
  id: "pendingmemberModal",
  tabindex: "-1",
  "aria-labelledby": "pendingmemberModalLabel",
  "aria-hidden": "true"
}
const _hoisted_632 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_633 = { class: "modal-content" }
const _hoisted_634 = { class: "modal-header" }
const _hoisted_635 = {
  class: "modal-title",
  id: "pendingmemberModalLabel"
}
const _hoisted_636 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_637 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_638 = { class: "col-sm-8 mb-2" }
const _hoisted_639 = { class: "member-list pr-0" }
const _hoisted_640 = { class: "round-img" }
const _hoisted_641 = {
  key: 0,
  class: "text-lowercase"
}
const _hoisted_642 = {
  key: 1,
  class: "text-lowercase"
}
const _hoisted_643 = {
  key: 0,
  class: "col-sm-4 text-sm-right mb-2"
}
const _hoisted_644 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash" }, null, -1)
const _hoisted_645 = /*#__PURE__*/_createVNode("i", { class: "fa fa-share" }, null, -1)
const _hoisted_646 = { class: "modal-footer" }
const _hoisted_647 = { class: "modal-wrap remove-user-modal default-modal" }
const _hoisted_648 = {
  class: "modal fade",
  id: "modifyHistoryBymember",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_649 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_650 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_651 = { class: "modal-header border-0" }
const _hoisted_652 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_653 = { class: "modal-body" }
const _hoisted_654 = /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Include Conversation History ?", -1)
const _hoisted_655 = /*#__PURE__*/_createVNode("p", { class: "text-muted" }, "Choose whether the listed user can see past messages and files once they're added to the conversation. ", -1)
const _hoisted_656 = { class: "form-group mt-3" }
const _hoisted_657 = /*#__PURE__*/_createTextVNode(" From Invitation Accepted ")
const _hoisted_658 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_659 = /*#__PURE__*/_createTextVNode(" From Today ")
const _hoisted_660 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_661 = /*#__PURE__*/_createTextVNode(" From The Beginning ")
const _hoisted_662 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_663 = /*#__PURE__*/_createTextVNode(" Custom ")
const _hoisted_664 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_665 = {
  key: 0,
  class: "row"
}
const _hoisted_666 = { class: "col-md-3" }
const _hoisted_667 = { class: "form-group" }
const _hoisted_668 = { class: "modal-footer" }
const _hoisted_669 = { class: "modal-wrap remove-user-modal default-modal" }
const _hoisted_670 = {
  class: "modal fade",
  id: "removependingmember",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_671 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_672 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_673 = { class: "modal-header border-0" }
const _hoisted_674 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_675 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_676 = {
  class: "alert alert-danger text-center",
  role: "alert"
}
const _hoisted_677 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_678 = { class: "modal-footer" }
const _hoisted_679 = { class: "modal-wrap remove-user-modal default-modal" }
const _hoisted_680 = {
  class: "modal fade",
  id: "resendinvitationpendingmember",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_681 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_682 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_683 = { class: "modal-header" }
const _hoisted_684 = {
  key: 0,
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_685 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_686 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_687 = { class: "block-list" }
const _hoisted_688 = { class: "modal-footer" }
const _hoisted_689 = { class: "modal-wrap default-modal" }
const _hoisted_690 = {
  class: "modal fade",
  id: "editChannelModal",
  tabindex: "-1",
  "aria-labelledby": "renameModalLabel",
  "aria-hidden": "true"
}
const _hoisted_691 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_692 = { class: "modal-content" }
const _hoisted_693 = { class: "modal-header" }
const _hoisted_694 = {
  class: "modal-title",
  id: "renameModalLabel"
}
const _hoisted_695 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_696 = { class: "modal-body" }
const _hoisted_697 = { class: "px-3" }
const _hoisted_698 = { class: "form-group" }
const _hoisted_699 = { for: "exampleInputEmail1" }
const _hoisted_700 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "*", -1)
const _hoisted_701 = { class: "form-group" }
const _hoisted_702 = { for: "exampleInputEmail1" }
const _hoisted_703 = { class: "modal-footer" }
const _hoisted_704 = { class: "modal-wrap default-modal" }
const _hoisted_705 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "createToDo",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_706 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_707 = { class: "modal-content" }
const _hoisted_708 = { class: "modal-header" }
const _hoisted_709 = { class: "d-block" }
const _hoisted_710 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_711 = { class: "text-muted" }
const _hoisted_712 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_713 = { class: "modal-body" }
const _hoisted_714 = { class: "pt-0" }
const _hoisted_715 = { class: "form-group" }
const _hoisted_716 = { for: "exampleInputEmail1" }
const _hoisted_717 = { class: "modal-footer" }
const _hoisted_718 = { class: "modal-wrap remove-user-modal default-modal" }
const _hoisted_719 = {
  class: "modal fade",
  id: "removeProjectShareInvitation",
  tabindex: -1,
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_720 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_721 = {
  key: 0,
  class: "modal-content h-auto"
}
const _hoisted_722 = { class: "modal-header" }
const _hoisted_723 = {
  key: 0,
  class: "modal-title to-upper",
  id: "exampleModalLabel"
}
const _hoisted_724 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_725 = { class: "modal-body" }
const _hoisted_726 = { class: "block-list" }
const _hoisted_727 = { class: "modal-footer" }
const _hoisted_728 = { class: "modal-wrap default-modal" }
const _hoisted_729 = {
  class: "modal fade",
  id: "hideChannelModal",
  tabindex: -1,
  "aria-labelledby": "hidePojectLabel",
  "aria-hidden": "true"
}
const _hoisted_730 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_731 = { class: "modal-content" }
const _hoisted_732 = { class: "modal-header" }
const _hoisted_733 = {
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_734 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_735 = { class: "modal-body" }
const _hoisted_736 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_737 = { class: "modal-footer" }
const _hoisted_738 = { class: "modal-wrap default-modal" }
const _hoisted_739 = {
  class: "modal fade",
  id: "showChannelModal",
  tabindex: "-1",
  "aria-labelledby": "showPojectLabel",
  "aria-hidden": "true"
}
const _hoisted_740 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_741 = { class: "modal-content" }
const _hoisted_742 = { class: "modal-header" }
const _hoisted_743 = {
  class: "modal-title",
  id: "showPojectLabel"
}
const _hoisted_744 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_745 = { class: "modal-body" }
const _hoisted_746 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_747 = { class: "modal-footer" }
const _hoisted_748 = { class: "modal-wrap default-modal" }
const _hoisted_749 = {
  class: "modal fade",
  id: "addFavProjectModal",
  tabindex: "-1",
  "aria-labelledby": "addFavPojectLabel",
  "aria-hidden": "true"
}
const _hoisted_750 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_751 = { class: "modal-content" }
const _hoisted_752 = { class: "modal-header" }
const _hoisted_753 = {
  class: "modal-title",
  id: "addFavPojectLabel"
}
const _hoisted_754 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_755 = { class: "modal-body" }
const _hoisted_756 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_757 = { class: "modal-footer" }
const _hoisted_758 = { class: "modal-wrap default-modal" }
const _hoisted_759 = {
  class: "modal fade",
  id: "removeFavProjectModal",
  tabindex: "-1",
  "aria-labelledby": "removeFavPojectLabel",
  "aria-hidden": "true"
}
const _hoisted_760 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_761 = { class: "modal-content" }
const _hoisted_762 = { class: "modal-header" }
const _hoisted_763 = {
  class: "modal-title",
  id: "removeFavPojectLabel"
}
const _hoisted_764 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_765 = { class: "modal-body" }
const _hoisted_766 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_767 = { class: "modal-footer" }
const _hoisted_768 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_769 = {
  class: "modal fade default-modal",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "createPrivateChannel",
  tabindex: "-1",
  "aria-labelledby": "inviteMember",
  "aria-hidden": "true"
}
const _hoisted_770 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_771 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_772 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_773 = { class: "modal-content" }
const _hoisted_774 = { class: "modal-header" }
const _hoisted_775 = { class: "d-block" }
const _hoisted_776 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_777 = { class: "text-muted" }
const _hoisted_778 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_779 = { class: "modal-body" }
const _hoisted_780 = { class: "form-group pt-0" }
const _hoisted_781 = { key: 0 }
const _hoisted_782 = {
  key: 0,
  class: "form-group"
}
const _hoisted_783 = { for: "exampleInputEmail1" }
const _hoisted_784 = { class: "email-tag" }
const _hoisted_785 = { class: "mb-0" }
const _hoisted_786 = { class: "form-group" }
const _hoisted_787 = { for: "exampleInputEmail1" }
const _hoisted_788 = { class: "mb-0" }
const _hoisted_789 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_790 = { class: "form-group" }
const _hoisted_791 = { for: "exampleInputEmail1" }
const _hoisted_792 = { class: "input-btn" }
const _hoisted_793 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_794 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_795 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_796 = {
  key: 3,
  class: "table-wrap table-responsive"
}
const _hoisted_797 = { class: "table table-bordered table-shadowed my-3 font-12" }
const _hoisted_798 = { class: "table-primary nowrap-text" }
const _hoisted_799 = { class: "to-upper" }
const _hoisted_800 = { class: "form-group mb-0" }
const _hoisted_801 = { class: "form-group" }
const _hoisted_802 = { class: "input-group" }
const _hoisted_803 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("span", { class: "input-group-text" }, "+1")
], -1)
const _hoisted_804 = { class: "form-group mb-0" }
const _hoisted_805 = { class: "form-group mb-0" }
const _hoisted_806 = { class: "form-group" }
const _hoisted_807 = {
  class: "notify-by-form-group",
  id: "notifyByFormGroup"
}
const _hoisted_808 = { class: "form-check form-check-inline" }
const _hoisted_809 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "inlineCheckbox1"
}, "Email", -1)
const _hoisted_810 = { class: "form-check form-check-inline" }
const _hoisted_811 = {
  class: "form-check-label",
  for: "inlineCheckbox2"
}
const _hoisted_812 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_813 = { class: "modal-footer" }
const _hoisted_814 = { class: "modal-wrap default-modal" }
const _hoisted_815 = {
  class: "modal fade",
  id: "renameModal",
  tabindex: "-1",
  "aria-labelledby": "renameModalLabel",
  "aria-hidden": "true"
}
const _hoisted_816 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_817 = { class: "modal-content" }
const _hoisted_818 = { class: "modal-header" }
const _hoisted_819 = {
  key: 0,
  class: "modal-title to-upper",
  id: "renameModalLabel"
}
const _hoisted_820 = {
  key: 1,
  class: "modal-title",
  id: "renameModalLabel"
}
const _hoisted_821 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_822 = { class: "modal-body" }
const _hoisted_823 = { class: "text-end mb-3" }
const _hoisted_824 = /*#__PURE__*/_createVNode("i", { class: "fa fa-pen" }, null, -1)
const _hoisted_825 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_826 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "(*)", -1)
const _hoisted_827 = {
  key: 1,
  class: "alert alert-success"
}
const _hoisted_828 = { class: "form-group" }
const _hoisted_829 = { for: "exampleInputEmail1" }
const _hoisted_830 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_831 = { class: "form-group" }
const _hoisted_832 = { for: "exampleInputEmail1" }
const _hoisted_833 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_834 = { class: "form-group" }
const _hoisted_835 = { for: "exampleInputEmail1" }
const _hoisted_836 = { class: "form-group" }
const _hoisted_837 = { for: "projectAddress" }
const _hoisted_838 = { class: "modal-footer" }
const _hoisted_839 = { class: "modal-body" }
const _hoisted_840 = /*#__PURE__*/_createVNode("span", { class: "animating-arrow" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-right" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_multiselect = _resolveComponent("multiselect")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_draggable = _resolveComponent("draggable")
  const _component_EmptyData = _resolveComponent("EmptyData")
  const _component_TemplateCard = _resolveComponent("TemplateCard")
  const _component_HistoryCard = _resolveComponent("HistoryCard")
  const _component_AppPhoneNumberInput = _resolveComponent("AppPhoneNumberInput")
  const _component_v_date_picker = _resolveComponent("v-date-picker")
  const _component_treeselect = _resolveComponent("treeselect")
  const _component_ToDoDetailsAttachment = _resolveComponent("ToDoDetailsAttachment")
  const _component_GoogleMapView = _resolveComponent("GoogleMapView")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_UpgradeSubscriptionModal = _resolveComponent("UpgradeSubscriptionModal")
  const _component_ProjectImageUploadModal = _resolveComponent("ProjectImageUploadModal")
  const _component_ProjectApprovalModal = _resolveComponent("ProjectApprovalModal")
  const _component_ProjectApprovalModalEdit = _resolveComponent("ProjectApprovalModalEdit")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", null, [
      ((_ctx.state.isLoading.getProjectDetail &&
          !_ctx.state.ui.isLoading.projectDetailsAPICalled) || (_ctx.state.isLoading.getProjectChannel && !_ctx.state.isLoading.searchProjectChannel && !_ctx.state.data.inviteAsPublicUser && !_ctx.state.postLoading.inviteAllUsers && !_ctx.state.postLoading.createChannel))
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _hoisted_2
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_3, [
        _createVNode("nav", _hoisted_4, [
          _createVNode("ol", _hoisted_5, [
            _createVNode("li", _hoisted_6, [
              _createVNode(_component_router_link, { to: { name: 'admin-dashboard' } }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('home')), 1)
                ]),
                _: 1
              })
            ]),
            _createVNode("li", _hoisted_8, [
              _createVNode("a", _hoisted_9, _toDisplayString(_ctx.$t('project_name')), 1)
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode("h1", _hoisted_13, [
              _createTextVNode(_toDisplayString(_ctx.$t('project')) + " : " + _toDisplayString(_ctx.state.projectDetail.name) + " ", 1),
              _createVNode("button", {
                class: "badge info-bage badge badge-primary pointer-cursor mr-1",
                "data-toggle": "modal",
                title: "view project details",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.renameProjectModal && _ctx.renameProjectModal(...args)))
              }, _toDisplayString(_ctx.$t('view_project_details')), 1),
              _createVNode("button", {
                class: "badge info-bage badge badge-dark pointer-cursor mr-1",
                "data-toggle": "modal",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeProjectImageUploadModal && _ctx.closeProjectImageUploadModal(...args))),
                title: "view project gallery"
              }, _toDisplayString(_ctx.$t('view_project_gallery')), 1),
              (_ctx.state.projectDetail.fav == 1)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    class: "badge info-bage badge pointer-cursor mr-1 pinned-badge",
                    "data-toggle": "modal",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.removeFavProjectShow && _ctx.removeFavProjectShow(...args))),
                    title: "Unpin"
                  }, [
                    _hoisted_14,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('unpin_project')), 1)
                  ]))
                : (_openBlock(), _createBlock("button", {
                    key: 1,
                    class: "badge info-bage badge pointer-cursor mr-1 unpinned-badge",
                    "data-toggle": "modal",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addFavProjectShow && _ctx.addFavProjectShow(...args))),
                    title: "This Project will be display at the top on Dashboard"
                  }, [
                    _hoisted_15,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('pin_project')), 1)
                  ]))
            ])
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode(_component_router_link, {
              to: { name: 'admin-dashboard' },
              class: "btn default-btn"
            }, {
              default: _withCtx(() => [
                _hoisted_17,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode("div", _hoisted_18, [
        _createVNode("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, [
              _createVNode("div", _hoisted_22, [
                _createVNode("div", _hoisted_23, [
                  _createVNode("div", _hoisted_24, [
                    _createVNode("ul", null, [
                      _createVNode("li", null, [
                        _createVNode("div", _hoisted_25, [
                          _createVNode(_component_multiselect, {
                            modelValue: _ctx.channelListSelected,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.channelListSelected = $event)),
                            options: _ctx.channelLists,
                            "close-on-select": "true",
                            "clear-on-select": "true",
                            onSelect: _cache[6] || (_cache[6] = ($event: any) => (_ctx.searchChannel(_ctx.channelListSelected))),
                            placeholder: _ctx.$t('search_and_select'),
                            label: "name",
                            "track-by": "name"
                          }, null, 8, ["modelValue", "options", "placeholder"])
                        ])
                      ]),
                      _createVNode("li", null, [
                        _createVNode("a", {
                          href: "javascript:void(0)",
                          class: "text-success to-upper",
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.searchChannelRemove && _ctx.searchChannelRemove(...args)))
                        }, [
                          _hoisted_26,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('reset')), 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_27, [
                  _createVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _withDirectives(_createVNode("select", {
                      class: "form-control",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.data.channelStatus = $event)),
                      onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.changeChannelStatus && _ctx.changeChannelStatus(...args)))
                    }, [
                      _createVNode("option", _hoisted_30, _toDisplayString(_ctx.$t('active')), 1),
                      _createVNode("option", _hoisted_31, _toDisplayString(_ctx.$t('closed')), 1),
                      _createVNode("option", _hoisted_32, _toDisplayString(_ctx.$t('hide')), 1)
                    ], 544), [
                      [_vModelSelect, _ctx.state.data.channelStatus]
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_33, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.errors.errorList.errorList,
                hasError: _ctx.state.ui.errors.hasError
              }, null, 8, ["errors", "hasError"])
            ]),
            _createVNode("div", _hoisted_34, [
              _createVNode("div", _hoisted_35, [
                _createVNode("div", _hoisted_36, [
                  _createVNode("h3", _hoisted_37, [
                    _hoisted_38,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('chat_channels')) + " ", 1),
                    _createVNode("span", null, " (" + _toDisplayString(_ctx.state.channelList.length) + ")", 1)
                  ])
                ]),
                (_ctx.isUserStatus)
                  ? (_openBlock(), _createBlock("div", _hoisted_39, [
                      _createVNode("a", {
                        id: "createChannel",
                        href: "javascript:void(0)",
                        class: "d-block create-url mt-2 mt-sm-0",
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showCreateProjectChannel && _ctx.showCreateProjectChannel(...args)))
                      }, [
                        _hoisted_40,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('create_channel')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_41, [
              _createVNode("div", _hoisted_42, [
                (_ctx.state.isLoading.searchProjectChannel)
                  ? (_openBlock(), _createBlock("div", _hoisted_43, [
                      _createVNode("img", {
                        src: _ctx.state.data.imageBaseUrl
                    ? `${_ctx.state.data.imageBaseUrl}img/loading.gif`
                    : 'img/loading.gif'
                    ,
                        alt: ""
                      }, null, 8, ["src"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_44, [
                  (_ctx.state.channelList && _ctx.state.channelList.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_45, [
                        _createVNode(_component_draggable, {
                          class: "dragArea list-group w-full",
                          disabled: _ctx.isMobile,
                          holdToMove: true,
                          list: _ctx.state.channelList,
                          onChange: _ctx.orderChange
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_TransitionGroup, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.channelList, (channel, channelIndex) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "channel-card bg-white shadowed-box rounded",
                                    key: channelIndex
                                  }, [
                                    _createVNode("div", _hoisted_46, [
                                      _createVNode("h5", _hoisted_47, [
                                        _createVNode(_component_router_link, {
                                          to: {
                              name: 'admin-channel',
                              params: { channelId: channel.uuid },
                            },
                                          class: "d-block"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('channel')) + " : " + _toDisplayString(channel.name) + " ", 1),
                                            _hoisted_48,
                                            (channel.notification_count)
                                              ? (_openBlock(), _createBlock("span", _hoisted_49, _toDisplayString(channel.notification_count) + " " + _toDisplayString(_ctx.$t('unread_message')), 1))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"])
                                      ]),
                                      _createVNode("div", _hoisted_50, [
                                        _createVNode("div", _hoisted_51, [
                                          _hoisted_52,
                                          _createVNode("div", _hoisted_53, [
                                            (_ctx.isUserStatus)
                                              ? (_openBlock(), _createBlock("a", {
                                                  key: 0,
                                                  class: "dropdown-item to-upper",
                                                  href: "javascript:void(0)",
                                                  onClick: ($event: any) => (_ctx.showEditChannelModal(channel))
                                                }, [
                                                  _hoisted_54,
                                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                                                ], 8, ["onClick"]))
                                              : _createCommentVNode("", true),
                                            (channel.visible)
                                              ? (_openBlock(), _createBlock("a", {
                                                  key: 1,
                                                  class: "dropdown-item",
                                                  href: "javascript:void(0)",
                                                  onClick: ($event: any) => (_ctx.showChannelShow(channel))
                                                }, [
                                                  _hoisted_55,
                                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('show')), 1)
                                                ], 8, ["onClick"]))
                                              : _createCommentVNode("", true),
                                            (!channel.visible)
                                              ? (_openBlock(), _createBlock("a", {
                                                  key: 2,
                                                  class: "dropdown-item",
                                                  href: "javascript:void(0)",
                                                  onClick: ($event: any) => (_ctx.hideChannelShow(channel))
                                                }, [
                                                  _hoisted_56,
                                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('hide')), 1)
                                                ], 8, ["onClick"]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_57, [
                                      _createVNode("p", null, _toDisplayString(channel.description), 1),
                                      _createVNode("p", _hoisted_58, [
                                        _createVNode("strong", null, _toDisplayString(_ctx.$t('status')) + " :", 1),
                                        (channel.status_id === 1)
                                          ? (_openBlock(), _createBlock("span", _hoisted_59, _toDisplayString(channel.status.name), 1))
                                          : (_openBlock(), _createBlock("span", _hoisted_60, _toDisplayString(_ctx.$t('closed')), 1))
                                      ])
                                    ]),
                                    _createVNode("p", null, [
                                      _createVNode("small", null, [
                                        _hoisted_61,
                                        _createTextVNode(" " + _toDisplayString(channel.created_info), 1)
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_62, [
                                      _createVNode("div", _hoisted_63, [
                                        (channel.members &&
                                channel.members.length &&
                                _ctx.state.projectDetail.deleted_at == null
                              )
                                          ? (_openBlock(), _createBlock("div", _hoisted_64, [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(channel.members.slice(
                                  0,
                                  3
                                ), (member, memberIndex) => {
                                                return (_openBlock(), _createBlock("a", {
                                                  href: "javascript:void(0)",
                                                  key: memberIndex
                                                }, [
                                                  (!member.deleted_at)
                                                    ? (_openBlock(), _createBlock("span", _hoisted_65, [
                                                        (member.user.image)
                                                          ? (_openBlock(), _createBlock("img", {
                                                              key: 0,
                                                              src: member.user.image,
                                                              alt: "",
                                                              title: `${member.user.full_name}` +
                                      '(' +
                                      `${member.user.email}` +
                                      ')'
                                      
                                                            }, null, 8, ["src", "title"]))
                                                          : (_openBlock(), _createBlock("img", {
                                                              key: 1,
                                                              src: _ctx.state.data.imageBaseUrl
                                      ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                                      : 'img/no-user.jpg'
                                      ,
                                                              alt: "",
                                                              title: `${member.user.full_name}` +
                                        '(' +
                                        `${member.user.email}` +
                                        ')'
                                        
                                                            }, null, 8, ["src", "title"]))
                                                      ]))
                                                    : (channel.members &&
                                    channel.members.length &&
                                    _ctx.state.projectDetail.deleted_at != null
                                  )
                                                      ? (_openBlock(), _createBlock("span", _hoisted_66, [
                                                          (member.user.image)
                                                            ? (_openBlock(), _createBlock("img", {
                                                                key: 0,
                                                                src: member.user.image,
                                                                alt: "",
                                                                title: `${member.user.full_name}` +
                                      '(' +
                                      `${member.user.email}` +
                                      ')'
                                      
                                                              }, null, 8, ["src", "title"]))
                                                            : (_openBlock(), _createBlock("img", {
                                                                key: 1,
                                                                src: _ctx.state.data.imageBaseUrl
                                      ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                                      : 'img/no-user.jpg'
                                      ,
                                                                alt: "",
                                                                title: `${member.user.full_name}` +
                                        '(' +
                                        `${member.user.email}` +
                                        ')'
                                        
                                                              }, null, 8, ["src", "title"]))
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                ]))
                                              }), 128)),
                                              (channel.members.length > 3)
                                                ? (_openBlock(), _createBlock("a", {
                                                    key: 0,
                                                    href: "javascript:void(0)",
                                                    onClick: ($event: any) => (_ctx.showMemberList(channel.members))
                                                  }, [
                                                    _createVNode("span", _hoisted_67, "+" + _toDisplayString(channel.members.length - 3), 1)
                                                  ], 8, ["onClick"]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      (channel.status.code != 'closed')
                                        ? (_openBlock(), _createBlock("div", _hoisted_68, [
                                            (_ctx.isUserStatus)
                                              ? (_openBlock(), _createBlock("a", {
                                                  key: 0,
                                                  class: "d-block create-url",
                                                  href: "javascript:void(0)",
                                                  onClick: ($event: any) => (_ctx.addMember(channel))
                                                }, [
                                                  _hoisted_69,
                                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('add_member')), 1)
                                                ], 8, ["onClick"]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createVNode("div", _hoisted_70, [
                                      (channel.pending_members && channel.pending_members.length
                            )
                                        ? (_openBlock(), _createBlock("div", _hoisted_71, [
                                            _createVNode("a", {
                                              href: "javascript:void(0)",
                                              onClick: ($event: any) => (_ctx.showPendingList(channel)),
                                              class: "btn btn-outline-primary"
                                            }, [
                                              _hoisted_72,
                                              _createTextVNode(" " + _toDisplayString(_ctx.$t('pending_members')) + " (" + _toDisplayString(channel.pending_members_count) + ")", 1)
                                            ], 8, ["onClick"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["disabled", "list", "onChange"])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_73, [
                        _createVNode(_component_EmptyData, {
                          title: _ctx.state.channelTitle,
                          heading: _ctx.state.channelHeading
                        }, null, 8, ["title", "heading"])
                      ]))
                ])
              ]),
              (_ctx.state.data.estimationChatChannel &&
                _ctx.state.data.estimationChatChannel.length
              )
                ? (_openBlock(), _createBlock("div", _hoisted_74, [
                    _createVNode("div", _hoisted_75, [
                      _createVNode("h3", _hoisted_76, [
                        _hoisted_77,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('estimation_approval_discussion')), 1),
                        _createVNode("span", null, " (" + _toDisplayString(_ctx.state.data.estimationChatChannel.length) + ")", 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_78, [
                (_ctx.state.data.estimationChatChannel &&
                  _ctx.state.data.estimationChatChannel.length
                )
                  ? (_openBlock(), _createBlock("div", _hoisted_79, [
                      _createVNode("div", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                      .estimationChatChannel, (privateChannel, estimationChannelIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "channel-card bg-light rounded",
                            key: estimationChannelIndex
                          }, [
                            _createVNode("div", _hoisted_80, [
                              _createVNode("h5", _hoisted_81, [
                                _createVNode(_component_router_link, {
                                  to: {
                            name: 'admin-channel',
                            params: { channelId: privateChannel.channel.uuid },
                          },
                                  class: "d-block"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(privateChannel.channel.name) + " ", 1),
                                    (privateChannel.channel.notification_count)
                                      ? (_openBlock(), _createBlock("span", _hoisted_82, "(" + _toDisplayString(privateChannel.channel.notification_count) + ")", 1))
                                      : _createCommentVNode("", true),
                                    _hoisted_83,
                                    _hoisted_84
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ])
                            ]),
                            _createVNode("div", _hoisted_85, [
                              _createVNode("p", null, _toDisplayString(privateChannel.channel.description), 1),
                              _createVNode("div", _hoisted_86, [
                                _createVNode("div", _hoisted_87, [
                                  _createVNode("ul", null, [
                                    _createVNode("li", _hoisted_88, [
                                      (privateChannel.channel.members &&
                                  privateChannel.channel.members.length &&
                                  _ctx.state.projectDetail.deleted_at == null
                                )
                                        ? (_openBlock(), _createBlock("a", {
                                            key: 0,
                                            class: "to-upper",
                                            href: "javascript:void(0)",
                                            onClick: ($event: any) => (
                                  _ctx.showMemberList(privateChannel.channel.members)
                                  )
                                          }, [
                                            _hoisted_89,
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('members')) + " (" + _toDisplayString(privateChannel.channel.active_members_count) + ")", 1)
                                          ], 8, ["onClick"]))
                                        : (privateChannel.channel.members &&
                                  privateChannel.channel.members.length &&
                                  _ctx.state.projectDetail.deleted_at != null
                                )
                                          ? (_openBlock(), _createBlock("a", {
                                              key: 1,
                                              class: "to-upper",
                                              href: "javascript:void(0)",
                                              onClick: ($event: any) => (
                                  _ctx.showMemberList(privateChannel.channel.members)
                                  )
                                            }, [
                                              _hoisted_90,
                                              _createTextVNode(" " + _toDisplayString(_ctx.$t('members')) + " (" + _toDisplayString(privateChannel.channel.members_count) + ")", 1)
                                            ], 8, ["onClick"]))
                                          : (_openBlock(), _createBlock("a", _hoisted_91, [
                                              _hoisted_92,
                                              _createTextVNode(" " + _toDisplayString(_ctx.$t('no_members')), 1)
                                            ]))
                                    ])
                                  ])
                                ]),
                                (privateChannel.channel.pending_members &&
                            privateChannel.channel.pending_members.length
                          )
                                  ? (_openBlock(), _createBlock("div", _hoisted_93, [
                                      _createVNode("a", {
                                        href: "javascript:void(0)",
                                        onClick: ($event: any) => (_ctx.showPendingList(privateChannel.channel)),
                                        class: "btn btn-outline-primary"
                                      }, [
                                        _hoisted_94,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('pending_members')) + " (" + _toDisplayString(privateChannel.channel.pending_members_count) + ")", 1)
                                      ], 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createVNode("p", null, [
                              _createVNode("small", null, [
                                _hoisted_95,
                                _createTextVNode(" " + _toDisplayString(privateChannel.channel.created_info), 1)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.state.data.privateChatChannel &&
                _ctx.state.data.privateChatChannel.length
              )
                ? (_openBlock(), _createBlock("div", _hoisted_96, [
                    _createVNode("div", _hoisted_97, [
                      _createVNode("h3", _hoisted_98, [
                        _hoisted_99,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('private_channel')), 1),
                        _createVNode("span", null, " (" + _toDisplayString(_ctx.state.data.privateChatChannel.length) + ")", 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_100, [
                (_ctx.state.data.privateChatChannel &&
                  _ctx.state.data.privateChatChannel.length
                )
                  ? (_openBlock(), _createBlock("div", _hoisted_101, [
                      _createVNode("div", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                      .privateChatChannel, (privateChannel, privateChannelIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "channel-card bg-light rounded",
                            key: privateChannelIndex
                          }, [
                            _createVNode("div", _hoisted_102, [
                              _createVNode("h5", _hoisted_103, [
                                _createVNode(_component_router_link, {
                                  to: {
                          name: 'admin-channel',
                          params: { channelId: privateChannel.uuid },
                        },
                                  class: "d-block"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('channel')) + " : " + _toDisplayString(privateChannel.name) + " ", 1),
                                    _hoisted_104,
                                    (privateChannel.notification_count)
                                      ? (_openBlock(), _createBlock("span", _hoisted_105, "(" + _toDisplayString(privateChannel.notification_count) + ")", 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]),
                              (_ctx.isUserStatus)
                                ? (_openBlock(), _createBlock("div", _hoisted_106, [
                                    _createVNode("div", _hoisted_107, [
                                      _hoisted_108,
                                      _createVNode("div", _hoisted_109, [
                                        _createVNode("a", {
                                          class: "dropdown-item to-upper",
                                          href: "javascript:void(0)",
                                          onClick: ($event: any) => (_ctx.showEditChannelModal(privateChannel))
                                        }, [
                                          _hoisted_110,
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                                        ], 8, ["onClick"])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode("div", _hoisted_111, [
                              _createVNode("p", _hoisted_112, _toDisplayString(privateChannel.description), 1),
                              _createVNode("div", _hoisted_113, [
                                _createVNode("div", _hoisted_114, [
                                  (privateChannel.members &&
                              privateChannel.members.length &&
                              _ctx.state.projectDetail.deleted_at == null
                            )
                                    ? (_openBlock(), _createBlock("div", _hoisted_115, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(privateChannel.members.slice(
                                0,
                                3
                              ), (member, memberIndex) => {
                                          return (_openBlock(), _createBlock("a", {
                                            href: "javascript:void(0)",
                                            key: memberIndex
                                          }, [
                                            (!member.deleted_at)
                                              ? (_openBlock(), _createBlock("span", _hoisted_116, [
                                                  (member.user.image)
                                                    ? (_openBlock(), _createBlock("img", {
                                                        key: 0,
                                                        src: member.user.image,
                                                        alt: "",
                                                        title: `${member.user.full_name}` +
                                    '(' +
                                    `${member.user.email}` +
                                    ')'
                                    
                                                      }, null, 8, ["src", "title"]))
                                                    : (_openBlock(), _createBlock("img", {
                                                        key: 1,
                                                        src: _ctx.state.data.imageBaseUrl
                                    ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                                    : 'img/no-user.jpg'
                                    ,
                                                        alt: "",
                                                        title: `${member.user.full_name}` +
                                      '(' +
                                      `${member.user.email}` +
                                      ')'
                                      
                                                      }, null, 8, ["src", "title"]))
                                                ]))
                                              : (privateChannel.members &&
                                  privateChannel.members.length &&
                                  _ctx.state.projectDetail.deleted_at != null
                                )
                                                ? (_openBlock(), _createBlock("span", _hoisted_117, [
                                                    (member.user.image)
                                                      ? (_openBlock(), _createBlock("img", {
                                                          key: 0,
                                                          src: member.user.image,
                                                          alt: "",
                                                          title: `${member.user.full_name}` +
                                    '(' +
                                    `${member.user.email}` +
                                    ')'
                                    
                                                        }, null, 8, ["src", "title"]))
                                                      : (_openBlock(), _createBlock("img", {
                                                          key: 1,
                                                          src: _ctx.state.data.imageBaseUrl
                                    ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                                    : 'img/no-user.jpg'
                                    ,
                                                          alt: "",
                                                          title: `${member.user.full_name}` +
                                      '(' +
                                      `${member.user.email}` +
                                      ')'
                                      
                                                        }, null, 8, ["src", "title"]))
                                                  ]))
                                                : _createCommentVNode("", true)
                                          ]))
                                        }), 128)),
                                        (privateChannel.members.length > 3)
                                          ? (_openBlock(), _createBlock("a", {
                                              key: 0,
                                              href: "javascript:void(0)",
                                              onClick: ($event: any) => (_ctx.showMemberList(privateChannel.members))
                                            }, [
                                              _createVNode("span", _hoisted_118, "+" + _toDisplayString(privateChannel.members.length - 3), 1)
                                            ], 8, ["onClick"]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode("div", _hoisted_119, [
                                  (_ctx.isUserStatus)
                                    ? (_openBlock(), _createBlock("a", {
                                        key: 0,
                                        class: "d-block create-url",
                                        href: "javascript:void(0)",
                                        onClick: ($event: any) => (_ctx.addMemberInPrivateChannel(privateChannel))
                                      }, [
                                        _hoisted_120,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('add_member')), 1)
                                      ], 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createVNode("div", _hoisted_121, [
                                (privateChannel.pending_members &&
                            privateChannel.pending_members.length
                          )
                                  ? (_openBlock(), _createBlock("div", _hoisted_122, [
                                      _createVNode("a", {
                                        href: "javascript:void(0)",
                                        onClick: ($event: any) => (_ctx.showPendingList(privateChannel)),
                                        class: "btn btn-outline-primary"
                                      }, [
                                        _hoisted_123,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('pending_members')) + " (" + _toDisplayString(privateChannel.pending_members_count) + ")", 1)
                                      ], 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createVNode("p", null, [
                              _createVNode("small", null, [
                                _hoisted_124,
                                _createTextVNode(" " + _toDisplayString(privateChannel.created_info), 1)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.state.data.approvalChatChannel &&
                _ctx.state.data.approvalChatChannel.length
              )
                ? (_openBlock(), _createBlock("div", _hoisted_125, [
                    _createVNode("div", _hoisted_126, [
                      _createVNode("h3", _hoisted_127, [
                        _hoisted_128,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('contract_approval_discussion')), 1),
                        _createVNode("span", null, " (" + _toDisplayString(_ctx.state.data.approvalChatChannel.length) + ")", 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_129, [
                (_ctx.state.data.approvalChatChannel &&
                  _ctx.state.data.approvalChatChannel.length
                )
                  ? (_openBlock(), _createBlock("div", _hoisted_130, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                    .approvalChatChannel, (privateChannel, privateChannelIndex) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "channel-card bg-light rounded",
                          key: privateChannelIndex
                        }, [
                          _createVNode("div", _hoisted_131, [
                            _createVNode("h5", _hoisted_132, [
                              _createVNode(_component_router_link, {
                                to: {
                        name: 'admin-channel',
                        params: { channelId: privateChannel.channel.uuid },
                      },
                                class: "d-block"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('channel')) + " : " + _toDisplayString(privateChannel.channel.name) + " ", 1),
                                  _hoisted_133,
                                  (privateChannel.channel.notification_count)
                                    ? (_openBlock(), _createBlock("span", _hoisted_134, "(" + _toDisplayString(privateChannel.channel.notification_count) + ")", 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ])
                          ]),
                          _createVNode("div", _hoisted_135, [
                            _createVNode("p", null, _toDisplayString(privateChannel.channel.description), 1),
                            _createVNode("div", _hoisted_136, [
                              _createVNode("div", _hoisted_137, [
                                _createVNode("ul", null, [
                                  _createVNode("li", _hoisted_138, [
                                    (privateChannel.channel.members &&
                                privateChannel.channel.members.length &&
                                _ctx.state.projectDetail.deleted_at == null
                              )
                                      ? (_openBlock(), _createBlock("a", {
                                          key: 0,
                                          class: "to-upper",
                                          href: "javascript:void(0)",
                                          onClick: ($event: any) => (
                                _ctx.showMemberList(privateChannel.channel.members)
                                )
                                        }, [
                                          _hoisted_139,
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('members')) + " (" + _toDisplayString(privateChannel.channel.active_members_count) + ")", 1)
                                        ], 8, ["onClick"]))
                                      : (privateChannel.channel.members &&
                                privateChannel.channel.members.length &&
                                _ctx.state.projectDetail.deleted_at != null
                              )
                                        ? (_openBlock(), _createBlock("a", {
                                            key: 1,
                                            class: "to-upper",
                                            href: "javascript:void(0)",
                                            onClick: ($event: any) => (
                                _ctx.showMemberList(privateChannel.channel.members)
                                )
                                          }, [
                                            _hoisted_140,
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('members')) + " (" + _toDisplayString(privateChannel.channel.members_count) + ")", 1)
                                          ], 8, ["onClick"]))
                                        : (_openBlock(), _createBlock("a", _hoisted_141, [
                                            _hoisted_142,
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('no_members')), 1)
                                          ]))
                                  ])
                                ])
                              ]),
                              (privateChannel.channel.pending_members &&
                          privateChannel.channel.pending_members.length
                        )
                                ? (_openBlock(), _createBlock("div", _hoisted_143, [
                                    _createVNode("a", {
                                      href: "javascript:void(0)",
                                      onClick: ($event: any) => (_ctx.showPendingList(privateChannel.channel)),
                                      class: "btn btn-outline-primary"
                                    }, [
                                      _hoisted_144,
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t('pending_members')) + " (" + _toDisplayString(privateChannel.channel.pending_members_count) + ")", 1)
                                    ], 8, ["onClick"])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode("p", null, [
                            _createVNode("small", null, [
                              _hoisted_145,
                              _createTextVNode(" " + _toDisplayString(privateChannel.channel.created_info), 1)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.state.data.phaseChatChannel && _ctx.state.data.phaseChatChannel.length
              )
                ? (_openBlock(), _createBlock("div", _hoisted_146, [
                    _createVNode("div", _hoisted_147, [
                      _createVNode("h3", _hoisted_148, [
                        _hoisted_149,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('phase_task_discussion')), 1),
                        _createVNode("span", null, " (" + _toDisplayString(_ctx.state.data.phaseChatChannel.length) + ")", 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_150, [
                (_ctx.state.data.phaseChatChannel && _ctx.state.data.phaseChatChannel.length
                )
                  ? (_openBlock(), _createBlock("div", _hoisted_151, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                    .phaseChatChannel, (privateChannel, privateChannelIndex) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "channel-card",
                          key: privateChannelIndex
                        }, [
                          _createVNode("div", _hoisted_152, [
                            _createVNode("h5", _hoisted_153, [
                              _createVNode(_component_router_link, {
                                to: {
                        name: 'admin-channel',
                        params: { channelId: privateChannel.channel.uuid },
                      },
                                class: "d-block"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('channel')) + " : " + _toDisplayString(privateChannel.channel.name) + " ", 1),
                                  _hoisted_154,
                                  (privateChannel.channel.notification_count)
                                    ? (_openBlock(), _createBlock("span", _hoisted_155, "(" + _toDisplayString(privateChannel.channel.notification_count) + ")", 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ])
                          ]),
                          _createVNode("div", _hoisted_156, [
                            _createVNode("p", null, _toDisplayString(privateChannel.channel.description), 1),
                            _createVNode("div", _hoisted_157, [
                              _createVNode("div", _hoisted_158, [
                                _createVNode("ul", null, [
                                  _createVNode("li", _hoisted_159, [
                                    (privateChannel.channel.members &&
                                privateChannel.channel.members.length &&
                                _ctx.state.projectDetail.deleted_at == null
                              )
                                      ? (_openBlock(), _createBlock("a", {
                                          key: 0,
                                          class: "to-upper",
                                          href: "javascript:void(0)",
                                          onClick: ($event: any) => (
                                _ctx.showMemberList(privateChannel.channel.members)
                                )
                                        }, [
                                          _hoisted_160,
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('members')) + " (" + _toDisplayString(privateChannel.channel.active_members_count) + ")", 1)
                                        ], 8, ["onClick"]))
                                      : (privateChannel.channel.members &&
                                privateChannel.channel.members.length &&
                                _ctx.state.projectDetail.deleted_at != null
                              )
                                        ? (_openBlock(), _createBlock("a", {
                                            key: 1,
                                            class: "to-upper",
                                            href: "javascript:void(0)",
                                            onClick: ($event: any) => (
                                _ctx.showMemberList(privateChannel.channel.members)
                                )
                                          }, [
                                            _hoisted_161,
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('members')) + " (" + _toDisplayString(privateChannel.channel.members_count) + ")", 1)
                                          ], 8, ["onClick"]))
                                        : (_openBlock(), _createBlock("a", _hoisted_162, [
                                            _hoisted_163,
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('no_members')), 1)
                                          ]))
                                  ])
                                ])
                              ]),
                              (privateChannel.channel.pending_members &&
                          privateChannel.channel.pending_members.length
                        )
                                ? (_openBlock(), _createBlock("div", _hoisted_164, [
                                    _createVNode("a", {
                                      href: "javascript:void(0)",
                                      onClick: ($event: any) => (_ctx.showPendingList(privateChannel.channel)),
                                      class: "btn btn-outline-primary"
                                    }, [
                                      _hoisted_165,
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t('pending_members')) + " (" + _toDisplayString(privateChannel.channel.pending_members_count) + ")", 1)
                                    ], 8, ["onClick"])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode("p", null, [
                            _hoisted_166,
                            _createTextVNode(" " + _toDisplayString(privateChannel.channel.created_info), 1)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_167, [
          _createVNode("div", _hoisted_168, [
            _createVNode("ul", _hoisted_169, [
              _createVNode("li", _hoisted_170, [
                _createVNode("button", _hoisted_171, [
                  _hoisted_172,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('todo')), 1)
                ])
              ]),
              _createVNode("li", _hoisted_173, [
                _createVNode("button", _hoisted_174, [
                  _hoisted_175,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('forms')), 1)
                ])
              ]),
              _createVNode("li", _hoisted_176, [
                _createVNode("button", _hoisted_177, [
                  _hoisted_178,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('share_members')), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_179, [
              _createVNode("div", _hoisted_180, [
                _createVNode("div", _hoisted_181, [
                  (_ctx.state.projectDetail.todo)
                    ? (_openBlock(), _createBlock("div", _hoisted_182, [
                        _createVNode("div", _hoisted_183, [
                          _createVNode("ul", null, [
                            _createVNode("li", null, [
                              _createVNode("a", {
                                href: "javascript:void(0)",
                                class: "btn default-btn outline",
                                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.redirectToProjectCalendar && _ctx.redirectToProjectCalendar(...args)))
                              }, _toDisplayString(_ctx.$t('go_to_calendar')), 1)
                            ]),
                            (_ctx.state.todoData.status > 1 && (_ctx.state.data.projectRole === 'owner' || _ctx.state.data.projectRole === 'co-owner') && _ctx.state.projectDetail.estimation.status === 1)
                              ? (_openBlock(), _createBlock("li", _hoisted_184, [
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    class: "btn default-btn outline",
                                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.redirectToCreateEstimation()))
                                  }, _toDisplayString(_ctx.$t('edit_smart_contract')), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.todoData.status == 1 && _ctx.state.projectDetail.estimation.status === 1)
                              ? (_openBlock(), _createBlock("li", _hoisted_185, [
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    class: "btn default-btn outline",
                                    onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.showCreateEstimationModal && _ctx.showCreateEstimationModal(...args)))
                                  }, _toDisplayString(_ctx.$t('create_smart_contract')), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.data.projectRole === 'owner' || _ctx.state.data.projectRole === 'co-owner' || _ctx.state.data.projectRole === 'todo_payer' || _ctx.state.data.projectRole === 'estimation_member')
                              ? (_openBlock(), _createBlock("li", _hoisted_186, [
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    class: "btn default-btn outline",
                                    onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.gotoListJobEstimation && _ctx.gotoListJobEstimation(...args)))
                                  }, _toDisplayString(_ctx.$t('job_estimation')), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.projectDetail.smart_contract && _ctx.state.projectDetail.smart_contract.status === 1 && _ctx.smartContractAccess)
                              ? (_openBlock(), _createBlock("li", _hoisted_187, [
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    class: "btn default-btn outline",
                                    onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.goToSmartContract && _ctx.goToSmartContract(...args)))
                                  }, _toDisplayString(_ctx.$t('smart_contract_list')), 1)
                                ]))
                              : (_ctx.state.projectDetail.approval &&
                          _ctx.state.projectDetail.approval.payerRequest.status === 1
                        )
                                ? (_openBlock(), _createBlock("li", _hoisted_188, [
                                    _createVNode("span", {
                                      class: "badge badge-warning p-2",
                                      onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.showProjectAcknowledgementRequestDetails && _ctx.showProjectAcknowledgementRequestDetails(...args)))
                                    }, [
                                      _hoisted_189,
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t('invitation_pending')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.projectDetail.todo &&
                  _ctx.state.projectDetail.todo.invitations &&
                  _ctx.state.projectDetail.todo.invitations.length
                )
                  ? (_openBlock(), _createBlock("div", _hoisted_190, [
                      _createVNode("div", _hoisted_191, [
                        _createVNode("h3", _hoisted_192, _toDisplayString(_ctx.$t('todo_invitations')), 1)
                      ]),
                      _createVNode("div", _hoisted_193, [
                        _createVNode("div", _hoisted_194, [
                          _createVNode("table", _hoisted_195, [
                            _createVNode("thead", _hoisted_196, [
                              _createVNode("tr", null, [
                                _createVNode("td", null, _toDisplayString(_ctx.$t('invitations')), 1),
                                _createVNode("td", null, _toDisplayString(_ctx.$t('action')), 1)
                              ])
                            ]),
                            _createVNode("tbody", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.projectDetail.todo
                            .invitations, (phase, phaseIndex) => {
                                return (_openBlock(), _createBlock("tr", { key: phaseIndex }, [
                                  (phase.type === 4)
                                    ? (_openBlock(), _createBlock("td", _hoisted_197, [
                                        _createVNode("div", _hoisted_198, [
                                          _createVNode(_component_router_link, {
                                            to: {
                                  name: 'user-project-acknowledgement',
                                  params: { invitationId: phase.related_id },
                                }
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(phase.description), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["to"])
                                        ])
                                      ]))
                                    : (_openBlock(), _createBlock("td", _hoisted_199, [
                                        _createVNode("div", _hoisted_200, [
                                          _createVNode(_component_router_link, {
                                            to: {
                                  name: 'user-phase-task-invitation-acknowledgement',
                                  params: { invitationId: phase.uuid },
                                }
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(phase.description), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["to"])
                                        ])
                                      ])),
                                  (phase.type === 4)
                                    ? (_openBlock(), _createBlock("td", _hoisted_201, [
                                        _createVNode(_component_router_link, {
                                          title: "View Details",
                                          class: "default-btn btn btn-sm",
                                          to: {
                                name: 'user-project-acknowledgement',
                                params: { invitationId: phase.related_id },
                              }
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_202
                                          ]),
                                          _: 2
                                        }, 1032, ["to"])
                                      ]))
                                    : (_openBlock(), _createBlock("td", _hoisted_203, [
                                        _createVNode(_component_router_link, {
                                          title: "View Details",
                                          class: "default-btn btn btn-sm",
                                          to: {
                                name: 'user-phase-task-invitation-acknowledgement',
                                params: { invitationId: phase.uuid },
                              }
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_204
                                          ]),
                                          _: 2
                                        }, 1032, ["to"])
                                      ]))
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_205, [
                        (_ctx.state.projectDetail.todo && _ctx.state.projectDetail.todo.phases)
                          ? (_openBlock(), _createBlock("div", _hoisted_206, [
                              _createVNode("div", _hoisted_207, [
                                _createVNode("small", null, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('showing')) + " ", 1),
                                  (_ctx.state.projectDetail.todo.phases.to)
                                    ? (_openBlock(), _createBlock("span", _hoisted_208, _toDisplayString(_ctx.state.projectDetail.todo.phases.to), 1))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('of')) + " ", 1),
                                  (_ctx.state.projectDetail.todo.phases.total)
                                    ? (_openBlock(), _createBlock("span", _hoisted_209, _toDisplayString(_ctx.state.projectDetail.todo.phases.total), 1))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('result')), 1)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_210, [
                _createVNode("div", _hoisted_211, [
                  _createVNode("div", _hoisted_212, [
                    _createVNode("div", _hoisted_213, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.state.searchBy = $event)),
                        onKeyup: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.getAccountFormList && _ctx.getAccountFormList(...args)))
                      }, null, 544), [
                        [_vModelText, _ctx.state.searchBy]
                      ]),
                      _hoisted_214
                    ])
                  ]),
                  (_ctx.state.templateList && _ctx.state.templateList.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_215, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.templateList.slice(
                      0,
                      5
                    ), (template, templateIndex) => {
                          return (_openBlock(), _createBlock(_component_TemplateCard, {
                            template: template,
                            key: templateIndex,
                            isUserStatus: _ctx.isUserStatus
                          }, null, 8, ["template", "isUserStatus"]))
                        }), 128)),
                        _createVNode("div", _hoisted_216, [
                          _createVNode("a", _hoisted_217, [
                            _createVNode(_component_router_link, { to: { name: 'admin-project-forms' } }, {
                              default: _withCtx(() => [
                                _hoisted_218,
                                _hoisted_219
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_220, [
                        _createVNode(_component_EmptyData, {
                          title: _ctx.state.titleForTemplate,
                          heading: _ctx.state.headingForTemplate
                        }, null, 8, ["title", "heading"])
                      ]))
                ])
              ]),
              _createVNode("div", _hoisted_221, [
                (_ctx.state.data.projectRole === 'owner')
                  ? (_openBlock(), _createBlock("div", _hoisted_222, [
                      _createVNode("div", _hoisted_223, [
                        _createVNode("a", {
                          href: "javascript:void(0)",
                          class: "btn default-btn outline",
                          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.goToShareInvitation()))
                        }, [
                          _hoisted_224,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('share_phase')), 1)
                        ])
                      ]),
                      (_ctx.state.data.shareProjectMember && _ctx.state.data.shareProjectMember.length)
                        ? (_openBlock(), _createBlock("div", _hoisted_225, [
                            _createVNode("div", _hoisted_226, [
                              _createVNode("table", _hoisted_227, [
                                _createVNode("thead", _hoisted_228, [
                                  _createVNode("tr", null, [
                                    _createVNode("td", _hoisted_229, _toDisplayString(_ctx.$t('email')), 1),
                                    _createVNode("td", _hoisted_230, _toDisplayString(_ctx.$t('status')), 1),
                                    _createVNode("td", null, _toDisplayString(_ctx.$t('action')), 1)
                                  ])
                                ]),
                                _createVNode("tbody", null, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.shareProjectMember, (shareMember, shareProjectMemberIndex) => {
                                    return (_openBlock(), _createBlock("tr", { key: shareProjectMemberIndex }, [
                                      _createVNode("td", null, [
                                        _createVNode("div", _hoisted_231, [
                                          _createVNode("strong", null, [
                                            _createVNode("a", _hoisted_232, _toDisplayString(shareMember.email), 1)
                                          ])
                                        ])
                                      ]),
                                      _createVNode("td", null, [
                                        (shareMember.is_complete === 0 && shareMember.partial === 0 && shareMember.is_declined === 0)
                                          ? (_openBlock(), _createBlock("span", _hoisted_233, "Pending"))
                                          : _createCommentVNode("", true),
                                        (shareMember.is_complete === 0 && shareMember.partial === 1 && shareMember.is_declined === 0)
                                          ? (_openBlock(), _createBlock("span", _hoisted_234, "Partial"))
                                          : _createCommentVNode("", true),
                                        (shareMember.is_complete === 0 && shareMember.partial === 0 && shareMember.is_declined === 1
                              )
                                          ? (_openBlock(), _createBlock("span", _hoisted_235, _toDisplayString(_ctx.$t('declined')), 1))
                                          : _createCommentVNode("", true),
                                        (shareMember.is_complete === 1 && shareMember.partial === 0 && shareMember.is_declined === 0)
                                          ? (_openBlock(), _createBlock("span", _hoisted_236, "Completed"))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createVNode("td", null, [
                                        _createVNode("div", _hoisted_237, [
                                          _createVNode("div", _hoisted_238, [
                                            _hoisted_239,
                                            _createVNode("div", _hoisted_240, [
                                              _createVNode("a", {
                                                class: "dropdown-item to-upper",
                                                href: "javascript:void(0)",
                                                onClick: ($event: any) => (_ctx.shareProjectInvitationDetails(shareMember.id))
                                              }, [
                                                _hoisted_241,
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('view')), 1)
                                              ], 8, ["onClick"]),
                                              _createVNode("a", {
                                                class: "dropdown-item to-upper",
                                                href: "javascript:void(0)",
                                                onClick: ($event: any) => (_ctx.goToShareInvitationEdit(shareMember.id))
                                              }, [
                                                _hoisted_242,
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                                              ], 8, ["onClick"]),
                                              _createVNode("a", {
                                                class: "dropdown-item to-upper",
                                                href: "javascript:void(0)",
                                                onClick: ($event: any) => (_ctx.selectShareProjectRemove(shareMember))
                                              }, [
                                                _hoisted_243,
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                                              ], 8, ["onClick"])
                                            ])
                                          ])
                                        ])
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_244, [
                            _createVNode(_component_EmptyData, {
                              title: _ctx.state.titleForMember,
                              heading: _ctx.state.headingForMember
                            }, null, 8, ["title", "heading"])
                          ]))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_245, [
          _createVNode("div", _hoisted_246, [
            _createVNode("ul", _hoisted_247, [
              _createVNode("li", _hoisted_248, [
                _createVNode("button", _hoisted_249, [
                  _hoisted_250,
                  (_ctx.state.projectDetail.active_members_count != 0 ||
                    (_ctx.state.projectDetail.active_members_count != '0' &&
                      _ctx.state.projectDetail.deleted_at == null)
                  )
                    ? (_openBlock(), _createBlock("span", _hoisted_251, _toDisplayString(_ctx.$t('members')) + " (" + _toDisplayString(_ctx.state.projectDetail.approved_members_count) + ") ", 1))
                    : (_ctx.state.projectDetail.approved_members_count != 0 ||
                    (_ctx.state.projectDetail.approved_members_count != '0' &&
                      _ctx.state.projectDetail.deleted_at != null)
                  )
                      ? (_openBlock(), _createBlock("span", _hoisted_252, _toDisplayString(_ctx.$t('members')) + " (" + _toDisplayString(_ctx.state.projectDetail.approved_members_count) + ") ", 1))
                      : (_openBlock(), _createBlock("span", _hoisted_253, _toDisplayString(_ctx.$t('no_members')), 1))
                ])
              ]),
              _createVNode("li", _hoisted_254, [
                _createVNode("button", _hoisted_255, [
                  _hoisted_256,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('history')), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_257, [
              _createVNode("div", _hoisted_258, [
                _createVNode("div", _hoisted_259, [
                  _createVNode("div", _hoisted_260, [
                    (_ctx.state.activityList && _ctx.state.activityList.length)
                      ? (_openBlock(), _createBlock("div", _hoisted_261, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.activityList.slice(
                        0,
                        3
                      ), (activity, activityIndex) => {
                            return (_openBlock(), _createBlock(_component_HistoryCard, {
                              activity: activity,
                              key: activityIndex
                            }, null, 8, ["activity"]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_262, [
                          _createVNode(_component_EmptyData, {
                            title: _ctx.state.activityTitle,
                            heading: _ctx.state.activityHeading
                          }, null, 8, ["title", "heading"])
                        ]))
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_263, [
                _createVNode("div", _hoisted_264, [
                  _createVNode("div", _hoisted_265, [
                    _createVNode("div", _hoisted_266, [
                      _createVNode("ul", null, [
                        _createVNode("li", _hoisted_267, [
                          (_ctx.isUserStatus)
                            ? (_openBlock(), _createBlock("a", {
                                key: 0,
                                href: "javascript:void(0)",
                                class: "default-btn p-2",
                                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.addMember && _ctx.addMember(...args))),
                                id: "addMember"
                              }, [
                                _hoisted_268,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('add_member')), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("li", _hoisted_269, [
                          (_ctx.isUserStatus)
                            ? (_openBlock(), _createBlock("a", {
                                key: 0,
                                title: "create private channel",
                                href: "javascript:void(0)",
                                class: "default-btn p-2",
                                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.createPrivateChannel && _ctx.createPrivateChannel(...args)))
                              }, [
                                _hoisted_270,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('private_channel')), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.state.projectDetail.pending_members_count != '0')
                          ? (_openBlock(), _createBlock("li", _hoisted_271, [
                              _createVNode("div", _hoisted_272, [
                                _createVNode("a", _hoisted_273, [
                                  _createVNode("small", null, _toDisplayString(_ctx.$t('view_pending_member')) + " (" + _toDisplayString(_ctx.state.projectDetail.pending_members_count) + ")", 1)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  (_ctx.state.activeMemberList &&
                    _ctx.state.activeMemberList.length &&
                    _ctx.state.projectDetail.deleted_at == null
                  )
                    ? (_openBlock(), _createBlock("div", _hoisted_274, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.activeMemberList, (member, memderIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "member-list member-chat",
                            key: memderIndex
                          }, [
                            (member.user)
                              ? (_openBlock(), _createBlock("div", _hoisted_275, [
                                  (member.user.image)
                                    ? (_openBlock(), _createBlock("img", {
                                        key: 0,
                                        src: member.user.image,
                                        alt: member.user.email,
                                        title: member.user.email
                                      }, null, 8, ["src", "alt", "title"]))
                                    : (_openBlock(), _createBlock("img", {
                                        key: 1,
                                        src: _ctx.state.data.imageBaseUrl
                          ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                          : 'img/no-user.jpg'
                          ,
                                        alt: member.user.email,
                                        title: member.user.email
                                      }, null, 8, ["src", "alt", "title"]))
                                ]))
                              : _createCommentVNode("", true),
                            (member.user && member.user.full_name)
                              ? (_openBlock(), _createBlock("h5", _hoisted_276, [
                                  _createTextVNode(_toDisplayString(member.user.full_name) + " - ", 1),
                                  _createVNode("span", _hoisted_277, _toDisplayString(member.project_role.name), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (member.isLoading)
                              ? (_openBlock(), _createBlock("p", _hoisted_278, _toDisplayString(_ctx.$t('loading1')), 1))
                              : _createCommentVNode("", true),
                            (member.created_info)
                              ? (_openBlock(), _createBlock("span", _hoisted_279, [
                                  _hoisted_280,
                                  _createTextVNode(" " + _toDisplayString(member.created_info), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("div", _hoisted_281, [
                              ((_ctx.state.data.activeUserEmail != member.user.email &&
                          _ctx.isUserStatus) ||
                          (_ctx.state.data.activeUserEmail != member.user.email &&
                            !_ctx.isUserStatus &&
                            member.project_role.code != 'todo_payer')
                        )
                                ? (_openBlock(), _createBlock("a", {
                                    key: 0,
                                    class: "btn btn-sm default-btn outline mr-2",
                                    onClick: ($event: any) => (_ctx.privateChat(member)),
                                    href: "javascript:void(0)",
                                    title: "Private chat"
                                  }, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('chat')) + " ", 1),
                                    _hoisted_282
                                  ], 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              (member.isChangeRole &&
                          _ctx.isUserStatus &&
                          member.project_role.code != 'todo_payer' &&
                          member.project_role.code != 'todo_subcontractor' &&
                          member.project_role.code != 'todo_member'
                        )
                                ? (_openBlock(), _createBlock("a", {
                                    key: 1,
                                    title: "Change Role",
                                    class: "btn default-btn btn-sm mr-2",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.changeRole(member))
                                  }, [
                                    _hoisted_283
                                  ], 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              (member.isChangeRole &&
                          _ctx.isUserStatus &&
                          member.project_role.code != 'todo_payer' &&
                          member.project_role.code != 'todo_subcontractor' &&
                          member.project_role.code != 'todo_member'
                        )
                                ? (_openBlock(), _createBlock("span", _hoisted_284, [
                                    _createVNode("a", {
                                      class: "btn-sm",
                                      title: "Remove User",
                                      href: "javascript:void(0)",
                                      "data-toggle": "modal",
                                      onClick: ($event: any) => (_ctx.selectForMemberRemove(member))
                                    }, [
                                      _hoisted_285
                                    ], 8, ["onClick"])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_ctx.state.memberList &&
                    _ctx.state.memberList.length &&
                    _ctx.state.projectDetail.deleted_at != null
                  )
                      ? (_openBlock(), _createBlock("div", _hoisted_286, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.memberList, (member, memderIndex) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "member-list",
                              key: memderIndex
                            }, [
                              (member.user)
                                ? (_openBlock(), _createBlock("div", _hoisted_287, [
                                    (member.user.image)
                                      ? (_openBlock(), _createBlock("img", {
                                          key: 0,
                                          src: member.user.image,
                                          alt: "member.user.email",
                                          title: member.user.email
                                        }, null, 8, ["src", "title"]))
                                      : (_openBlock(), _createBlock("img", {
                                          key: 1,
                                          src: _ctx.state.data.imageBaseUrl
                          ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                          : 'img/no-user.jpg'
                          ,
                                          alt: ""
                                        }, null, 8, ["src"]))
                                  ]))
                                : _createCommentVNode("", true),
                              (member.user && member.user.full_name)
                                ? (_openBlock(), _createBlock("h5", _hoisted_288, _toDisplayString(member.user.full_name), 1))
                                : _createCommentVNode("", true),
                              (member.created_info)
                                ? (_openBlock(), _createBlock("span", _hoisted_289, [
                                    _hoisted_290,
                                    _createTextVNode(" " + _toDisplayString(member.created_info), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("p", null, [
                                _createTextVNode(_toDisplayString(member.project_role.name) + " ", 1),
                                _createVNode("span", _hoisted_291, [
                                  (member.isChangeRole && _ctx.isUserStatus)
                                    ? (_openBlock(), _createBlock("a", {
                                        key: 0,
                                        href: "javascript:void(0)",
                                        onClick: ($event: any) => (_ctx.changeRole(member))
                                      }, [
                                        _hoisted_292,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('change_role')), 1)
                                      ], 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              (member.isChangeRole && _ctx.isUserStatus)
                                ? (_openBlock(), _createBlock("div", _hoisted_293, [
                                    _createVNode("a", {
                                      href: "javascript:void(0)",
                                      "data-toggle": "modal",
                                      onClick: ($event: any) => (_ctx.selectForMemberRemove(member))
                                    }, [
                                      _hoisted_294,
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t('remove')), 1)
                                    ], 8, ["onClick"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_295, [
                          _createVNode(_component_EmptyData, {
                            title: _ctx.state.titleForMember,
                            heading: _ctx.state.headingForMember
                          }, null, 8, ["title", "heading"])
                        ]))
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_296, [
      _createVNode("div", _hoisted_297, [
        _createVNode("div", _hoisted_298, [
          _createVNode("div", _hoisted_299, [
            _createVNode("div", _hoisted_300, [
              _createVNode("div", _hoisted_301, [
                _createVNode("h5", _hoisted_302, _toDisplayString(_ctx.$t('create_channel')), 1),
                _createVNode("p", _hoisted_303, _toDisplayString(_ctx.$t('channels_team_communication')), 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.hideCreateChannel && _ctx.hideCreateChannel(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_304
              ])
            ]),
            _createVNode("div", _hoisted_305, [
              _createVNode("div", _hoisted_306, [
                _createVNode("label", _hoisted_307, [
                  _createTextVNode(_toDisplayString(_ctx.$t('channel_name')) + " ", 1),
                  _hoisted_308
                ]),
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "exampleInputEmail1",
                  "aria-describedby": "emailHelp",
                  placeholder: _ctx.$t('example_kitchen_modeling_team'),
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.state.createChannel.name = $event))
                }, null, 8, ["placeholder"]), [
                  [_vModelText, _ctx.state.createChannel.name]
                ])
              ]),
              _createVNode("div", _hoisted_309, [
                _createVNode("label", _hoisted_310, _toDisplayString(_ctx.$t('description')), 1),
                _withDirectives(_createVNode("textarea", {
                  class: "form-control",
                  name: "",
                  id: "",
                  cols: "30",
                  rows: "10",
                  placeholder: _ctx.$t('description_of_channel'),
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.state.createChannel.description = $event))
                }, null, 8, ["placeholder"]), [
                  [_vModelText, _ctx.state.createChannel.description]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_311, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.createChannel && _ctx.createChannel(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.createChannel
                    ? _ctx.$t('creating')
                    : _ctx.$t('create_channel')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_312, [
      _createVNode("div", _hoisted_313, [
        _createVNode("div", _hoisted_314, [
          _createVNode("div", _hoisted_315, [
            _createVNode("div", _hoisted_316, [
              _createVNode("div", _hoisted_317, [
                _createVNode("h5", _hoisted_318, _toDisplayString(_ctx.$t('send_template')), 1),
                _createVNode("p", _hoisted_319, _toDisplayString(_ctx.$t('send_template_contributors')) + ".", 1)
              ]),
              _hoisted_320
            ]),
            _createVNode("div", _hoisted_321, [
              _createVNode("div", _hoisted_322, [
                _createVNode("label", _hoisted_323, _toDisplayString(_ctx.$t('select_channel')), 1),
                _createVNode("textarea", {
                  class: "form-control",
                  name: "",
                  id: "",
                  cols: "30",
                  rows: "10",
                  placeholder: _ctx.$t('placeholder_channel_description')
                }, null, 8, ["placeholder"])
              ]),
              _createVNode("div", _hoisted_324, [
                _createVNode("label", _hoisted_325, _toDisplayString(_ctx.$t('mention_member')), 1),
                _createVNode("input", {
                  type: "email",
                  class: "form-control",
                  id: "exampleInputEmail1",
                  "aria-describedby": "emailHelp",
                  placeholder: '@' + _ctx.$t('member_name')
                }, null, 8, ["placeholder"])
              ])
            ]),
            _createVNode("div", _hoisted_326, [
              _createVNode("button", _hoisted_327, _toDisplayString(_ctx.$t('send')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_328, [
      _createVNode("div", _hoisted_329, [
        (_ctx.state.postLoading.inviteAllUsers)
          ? (_openBlock(), _createBlock("div", _hoisted_330, [
              _hoisted_331
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_332, [
          _createVNode("div", _hoisted_333, [
            _createVNode("div", _hoisted_334, [
              _createVNode("div", _hoisted_335, [
                _createVNode("h5", _hoisted_336, _toDisplayString(_ctx.$t('invite_member')), 1),
                _createVNode("p", _hoisted_337, _toDisplayString(_ctx.$t('create_project_collaboration')) + ". ", 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.hideAddMember && _ctx.hideAddMember(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_338
              ])
            ]),
            _createVNode("div", _hoisted_339, [
              _createVNode("div", _hoisted_340, [
                _createVNode(_component_ErrorList, {
                  errors: _ctx.state.errorList,
                  hasError: _ctx.state.isErrorStatus
                }, null, 8, ["errors", "hasError"]),
                (!_ctx.state.data.invitationVerify.showStatus)
                  ? (_openBlock(), _createBlock("div", _hoisted_341, [
                      _createVNode("div", _hoisted_342, [
                        _createVNode("ul", null, [
                          _createVNode("li", null, [
                            (!_ctx.state.data.inviteAsPublicUser)
                              ? (_openBlock(), _createBlock("div", _hoisted_343, [
                                  _createVNode("div", _hoisted_344, [
                                    _withDirectives(_createVNode("input", {
                                      type: "checkbox",
                                      class: "custom-control-input",
                                      id: "guestSwitch",
                                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.state.data.inviteAsGuest = $event))
                                    }, null, 512), [
                                      [_vModelCheckbox, _ctx.state.data.inviteAsGuest]
                                    ]),
                                    _createVNode("label", _hoisted_345, _toDisplayString(_ctx.$t('as_guest')), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("li", null, [
                            (!_ctx.state.data.inviteAsGuest)
                              ? (_openBlock(), _createBlock("div", _hoisted_346, [
                                  _createVNode("div", _hoisted_347, [
                                    _withDirectives(_createVNode("input", {
                                      type: "checkbox",
                                      class: "custom-control-input",
                                      id: "guestSwitch1",
                                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.state.data.inviteAsPublicUser = $event))
                                    }, null, 512), [
                                      [_vModelCheckbox, _ctx.state.data.inviteAsPublicUser]
                                    ]),
                                    _createVNode("label", _hoisted_348, _toDisplayString(_ctx.$t('as_public_user')), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      (_ctx.state.data.channelList && _ctx.state.data.channelList.length)
                        ? (_openBlock(), _createBlock("div", _hoisted_349, [
                            _createVNode("label", _hoisted_350, _toDisplayString(_ctx.$t('select_channel')), 1),
                            _createVNode(_component_multiselect, {
                              modelValue: _ctx.selectedChannels,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.selectedChannels = $event)),
                              options: _ctx.allChannels,
                              "close-on-select": "true",
                              "clear-on-select": true,
                              placeholder: _ctx.$t('search_and_select'),
                              label: "name",
                              "track-by": "name",
                              onSelect: _cache[30] || (_cache[30] = ($event: any) => (_ctx.selectToChange(_ctx.selectedChannels))),
                              disabled: _ctx.state.ui.modal.selectedFromChannel
                            }, null, 8, ["modelValue", "options", "placeholder", "disabled"]),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectedAllChannel, (channel, channelIndex) => {
                              return (_openBlock(), _createBlock("div", {
                                class: "email-tag",
                                key: channelIndex
                              }, [
                                _createVNode("p", _hoisted_351, [
                                  _createTextVNode(_toDisplayString(channel.name) + " ", 1),
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.removeSelectedChannel(channel))
                                  }, [
                                    (!_ctx.state.ui.modal.selectedFromChannel)
                                      ? (_openBlock(), _createBlock("i", _hoisted_352))
                                      : _createCommentVNode("", true)
                                  ], 8, ["onClick"])
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.state.showCheckChannelMessage)
                        ? (_openBlock(), _createBlock("div", _hoisted_353, [
                            _createVNode("p", _hoisted_354, [
                              _createVNode("small", null, _toDisplayString(_ctx.$t('dont_own_channel')), 1)
                            ]),
                            _createVNode("p", _hoisted_355, [
                              _createVNode("small", null, _toDisplayString(_ctx.$t('start_with_creating_channel')), 1)
                            ]),
                            _createVNode("p", null, [
                              (_ctx.isUserStatus)
                                ? (_openBlock(), _createBlock("a", {
                                    key: 0,
                                    href: "javascript:void(0)",
                                    class: "btn default-btn mt-2",
                                    onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.showCreateProjectChannel && _ctx.showCreateProjectChannel(...args)))
                                  }, [
                                    _hoisted_356,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('create_channel')), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.state.data.inviteAsGuest &&
                    !_ctx.state.data.inviteAsPublicUser && _ctx.allUsers && _ctx.allUsers.length > 1
                  )
                        ? (_openBlock(), _createBlock("div", _hoisted_357, [
                            _createVNode("label", _hoisted_358, _toDisplayString(_ctx.$t('invite_existing_member')), 1),
                            _createVNode(_component_multiselect, {
                              modelValue: _ctx.selectedUsers,
                              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.selectedUsers = $event)),
                              options: _ctx.allUsers,
                              "custom-label": _ctx.nameWithEmail,
                              "close-on-select": "true",
                              "clear-on-select": true,
                              placeholder: _ctx.$t('search_and_select'),
                              label: "email",
                              "track-by": "email",
                              onSelect: _cache[33] || (_cache[33] = ($event: any) => (_ctx.selectToChangeUsers(_ctx.selectedUsers)))
                            }, null, 8, ["modelValue", "options", "custom-label", "placeholder"]),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.users, (user, userIndex) => {
                              return (_openBlock(), _createBlock("div", {
                                class: "email-tag",
                                key: userIndex
                              }, [
                                (user.email && !user.phone)
                                  ? (_openBlock(), _createBlock("p", _hoisted_359, [
                                      _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.email) + ") ", 1),
                                      _createVNode("a", {
                                        href: "javascript:void(0)",
                                        onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                                      }, [
                                        _hoisted_360
                                      ], 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (user.phone && !user.email)
                                  ? (_openBlock(), _createBlock("p", _hoisted_361, [
                                      _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.phone) + ") ", 1),
                                      _createVNode("a", {
                                        href: "javascript:void(0)",
                                        onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                                      }, [
                                        _hoisted_362
                                      ], 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (user.phone && user.email)
                                  ? (_openBlock(), _createBlock("p", _hoisted_363, [
                                      _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.email) + ") - (" + _toDisplayString(user.phone) + ") ", 1),
                                      _createVNode("a", {
                                        href: "javascript:void(0)",
                                        onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                                      }, [
                                        _hoisted_364
                                      ], 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.state.data.inviteAsPublicUser)
                        ? (_openBlock(), _createBlock("div", _hoisted_365, [
                            _createVNode("label", _hoisted_366, _toDisplayString(_ctx.$t('invite_new_member')), 1),
                            (_ctx.state.inputError)
                              ? (_openBlock(), _createBlock("p", _hoisted_367, _toDisplayString(_ctx.$t('please_fill_field')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.state.duplicate)
                              ? (_openBlock(), _createBlock("p", _hoisted_368, _toDisplayString(_ctx.$t('email_already_used')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.state.invite.invites && _ctx.state.invite.invites.length)
                              ? (_openBlock(), _createBlock("div", _hoisted_369, [
                                  _createVNode("table", _hoisted_370, [
                                    _createVNode("thead", _hoisted_371, [
                                      _createVNode("tr", null, [
                                        _createVNode("td", null, _toDisplayString(_ctx.$t('first_name')), 1),
                                        _createVNode("td", null, _toDisplayString(_ctx.$t('last_name')), 1),
                                        _createVNode("td", null, _toDisplayString(_ctx.$t('mobile_number')), 1),
                                        _createVNode("td", null, _toDisplayString(_ctx.$t('email')), 1),
                                        _createVNode("td", null, _toDisplayString(_ctx.$t('notify_by')), 1),
                                        _createVNode("td", null, _toDisplayString(_ctx.$t('action')), 1)
                                      ])
                                    ]),
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.invites, (invite, inviteIndex) => {
                                      return (_openBlock(), _createBlock("tbody", { key: inviteIndex }, [
                                        _createVNode("tr", null, [
                                          _createVNode("td", null, [
                                            _createVNode("div", _hoisted_372, [
                                              _withDirectives(_createVNode("input", {
                                                type: "text",
                                                class: invite.fNameError ? 'form-control error-field' : 'form-control',
                                                "onUpdate:modelValue": ($event: any) => (invite.first_name = $event)
                                              }, null, 10, ["onUpdate:modelValue"]), [
                                                [_vModelText, invite.first_name]
                                              ])
                                            ])
                                          ]),
                                          _createVNode("td", null, [
                                            _createVNode("div", _hoisted_373, [
                                              _withDirectives(_createVNode("input", {
                                                type: "text",
                                                class: invite.lNameError ? 'form-control error-field' : 'form-control',
                                                "onUpdate:modelValue": ($event: any) => (invite.last_name = $event)
                                              }, null, 10, ["onUpdate:modelValue"]), [
                                                [_vModelText, invite.last_name]
                                              ])
                                            ])
                                          ]),
                                          _createVNode("td", null, [
                                            _createVNode("div", _hoisted_374, [
                                              _createVNode("div", _hoisted_375, [
                                                _createVNode(_component_AppPhoneNumberInput, {
                                                  modelValue: invite.phone,
                                                  "onUpdate:modelValue": ($event: any) => (invite.phone = $event),
                                                  onInput: ($event: any) => (_ctx.checkEmptyFields(inviteIndex, 'phone'))
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                                              ])
                                            ])
                                          ]),
                                          _createVNode("td", null, [
                                            _createVNode("div", _hoisted_376, [
                                              _withDirectives(_createVNode("input", {
                                                type: "email",
                                                class: "form-control",
                                                "onUpdate:modelValue": ($event: any) => (invite.email = $event),
                                                onInput: ($event: any) => (_ctx.checkEmptyFields(inviteIndex, 'email'))
                                              }, null, 40, ["onUpdate:modelValue", "onInput"]), [
                                                [_vModelText, invite.email]
                                              ])
                                            ])
                                          ]),
                                          _createVNode("td", null, [
                                            _createVNode("div", _hoisted_377, [
                                              _createVNode("div", _hoisted_378, [
                                                _createVNode("div", _hoisted_379, [
                                                  _withDirectives(_createVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    id: "inlineCheckbox1",
                                                    value: "true",
                                                    "onUpdate:modelValue": ($event: any) => (invite.mailNotification = $event)
                                                  }, null, 8, ["onUpdate:modelValue"]), [
                                                    [_vModelCheckbox, invite.mailNotification]
                                                  ]),
                                                  _hoisted_380
                                                ]),
                                                _createVNode("div", _hoisted_381, [
                                                  _withDirectives(_createVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    id: "inlineCheckbox2",
                                                    value: "true",
                                                    "onUpdate:modelValue": ($event: any) => (invite.smsNotification = $event)
                                                  }, null, 8, ["onUpdate:modelValue"]), [
                                                    [_vModelCheckbox, invite.smsNotification]
                                                  ]),
                                                  _createVNode("label", _hoisted_382, _toDisplayString(_ctx.$t('sms')), 1)
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _createVNode("td", _hoisted_383, [
                                            (_ctx.state.invite.invites.length === inviteIndex + 1)
                                              ? (_openBlock(), _createBlock("button", {
                                                  key: 0,
                                                  type: "button",
                                                  class: "btn btn-sm text-primary mr-1",
                                                  disabled: !_ctx.hasValidLastContact,
                                                  onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.addNewMember && _ctx.addNewMember(...args)))
                                                }, [
                                                  _hoisted_384,
                                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
                                                ], 8, ["disabled"]))
                                              : _createCommentVNode("", true),
                                            (_ctx.state.invite.invites.length != 1)
                                              ? (_openBlock(), _createBlock("a", {
                                                  key: 1,
                                                  title: "Delete",
                                                  href: "javascript:void(0)",
                                                  class: "btn btn-sm text-danger",
                                                  disabled: _ctx.state.invite.invites.length === 1,
                                                  onClick: ($event: any) => (_ctx.removeSelectedUser(invite))
                                                }, [
                                                  _hoisted_385,
                                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                                                ], 8, ["disabled", "onClick"]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("h5", _hoisted_386, _toDisplayString(_ctx.$t('include_conversation_history')), 1),
                            _createVNode("p", _hoisted_387, "C" + _toDisplayString(_ctx.$t('conversation_history_description')), 1),
                            _createVNode("div", _hoisted_388, [
                              _createVNode("div", _hoisted_389, [
                                _withDirectives(_createVNode("input", {
                                  type: "radio",
                                  id: "customRadioInline1",
                                  name: "customRadioInline",
                                  value: "1",
                                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.selectedValue = $event)),
                                  class: "custom-control-input"
                                }, null, 512), [
                                  [_vModelRadio, _ctx.selectedValue]
                                ]),
                                _createVNode("label", _hoisted_390, _toDisplayString(_ctx.$t('from_invitation_accepted')), 1)
                              ]),
                              _createVNode("div", _hoisted_391, [
                                _withDirectives(_createVNode("input", {
                                  type: "radio",
                                  id: "customRadioInline2",
                                  name: "customRadioInline",
                                  value: "2",
                                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.selectedValue = $event)),
                                  class: "custom-control-input"
                                }, null, 512), [
                                  [_vModelRadio, _ctx.selectedValue]
                                ]),
                                _createVNode("label", _hoisted_392, _toDisplayString(_ctx.$t('from_today')), 1)
                              ]),
                              _createVNode("div", _hoisted_393, [
                                _withDirectives(_createVNode("input", {
                                  type: "radio",
                                  id: "customRadioInline3",
                                  name: "customRadioInline",
                                  value: "3",
                                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.selectedValue = $event)),
                                  class: "custom-control-input"
                                }, null, 512), [
                                  [_vModelRadio, _ctx.selectedValue]
                                ]),
                                _createVNode("label", _hoisted_394, _toDisplayString(_ctx.$t('from_the_beginning')), 1)
                              ]),
                              _createVNode("div", _hoisted_395, [
                                _withDirectives(_createVNode("input", {
                                  type: "radio",
                                  id: "customRadioInline4",
                                  name: "customRadioInline",
                                  value: "4",
                                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.selectedValue = $event)),
                                  class: "custom-control-input"
                                }, null, 512), [
                                  [_vModelRadio, _ctx.selectedValue]
                                ]),
                                _createVNode("label", _hoisted_396, _toDisplayString(_ctx.$t('custom')), 1)
                              ])
                            ]),
                            (_ctx.selectedValue === '4')
                              ? (_openBlock(), _createBlock("div", _hoisted_397, [
                                  _createVNode("div", _hoisted_398, [
                                    _createVNode("div", _hoisted_399, [
                                      _createVNode(_component_v_date_picker, {
                                        modelValue: _ctx.selectedDateForMember,
                                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (_ctx.selectedDateForMember = $event))
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.errorList && _ctx.state.errorList.length && _ctx.state.isErrorStatus)
                              ? (_openBlock(), _createBlock("div", _hoisted_400, [
                                  _hoisted_401,
                                  _hoisted_402
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_403, [
                            _createVNode("label", _hoisted_404, _toDisplayString(_ctx.$t('invite_new_member_email_number')), 1),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.inviteAsPublic, (publicMember, indexPublicMember) => {
                              return (_openBlock(), _createBlock("div", {
                                class: "row mb-3 align-items-center",
                                key: indexPublicMember
                              }, [
                                _createVNode("div", _hoisted_405, [
                                  _createVNode("div", _hoisted_406, [
                                    _createVNode("label", _hoisted_407, _toDisplayString(_ctx.$t('full_name')), 1),
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      id: "exampleFullName",
                                      placeholder: _ctx.$t('your_full_name'),
                                      "onUpdate:modelValue": ($event: any) => (publicMember.name = $event)
                                    }, null, 8, ["placeholder", "onUpdate:modelValue"]), [
                                      [_vModelText, publicMember.name]
                                    ])
                                  ])
                                ]),
                                _createVNode("div", _hoisted_408, [
                                  _createVNode("div", _hoisted_409, [
                                    _createVNode("label", _hoisted_410, _toDisplayString(_ctx.$t('email')), 1),
                                    _withDirectives(_createVNode("input", {
                                      type: "email",
                                      class: "form-control",
                                      id: "exampleEmailInput",
                                      placeholder: "abc@convorally.com",
                                      "onUpdate:modelValue": ($event: any) => (publicMember.email = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, publicMember.email]
                                    ])
                                  ])
                                ]),
                                _createVNode("div", _hoisted_411, [
                                  _createVNode("div", _hoisted_412, [
                                    _createVNode("label", _hoisted_413, _toDisplayString(_ctx.$t('mobile_number')), 1),
                                    _createVNode("div", _hoisted_414, [
                                      _hoisted_415,
                                      _withDirectives(_createVNode("input", {
                                        type: "number",
                                        class: "form-control",
                                        id: "exampleMobileNumber",
                                        placeholder: _ctx.$t('mobile_number_only'),
                                        "onUpdate:modelValue": ($event: any) => (publicMember.phone = $event)
                                      }, null, 8, ["placeholder", "onUpdate:modelValue"]), [
                                        [_vModelText, publicMember.phone]
                                      ])
                                    ])
                                  ])
                                ]),
                                _createVNode("div", _hoisted_416, [
                                  _createVNode("label", _hoisted_417, _toDisplayString(_ctx.$t('notify_by')), 1),
                                  _createVNode("div", _hoisted_418, [
                                    _createVNode("div", _hoisted_419, [
                                      _withDirectives(_createVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        id: "inlineCheckbox1",
                                        value: "false",
                                        "onUpdate:modelValue": ($event: any) => (publicMember.mailNotification = $event)
                                      }, null, 8, ["onUpdate:modelValue"]), [
                                        [_vModelCheckbox, publicMember.mailNotification]
                                      ]),
                                      _createVNode("label", _hoisted_420, _toDisplayString(_ctx.$t('email')), 1)
                                    ]),
                                    _createVNode("div", _hoisted_421, [
                                      _withDirectives(_createVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        id: "inlineCheckbox2",
                                        value: "false",
                                        "onUpdate:modelValue": ($event: any) => (publicMember.smsNotification = $event)
                                      }, null, 8, ["onUpdate:modelValue"]), [
                                        [_vModelCheckbox, publicMember.smsNotification]
                                      ]),
                                      _createVNode("label", _hoisted_422, _toDisplayString(_ctx.$t('sms')), 1)
                                    ])
                                  ])
                                ]),
                                _createVNode("div", _hoisted_423, [
                                  (indexPublicMember + 1 ==
                          _ctx.state.inviteAsPublic.length ||
                          _ctx.state.inviteAsPublic.length === 1
                        )
                                    ? (_openBlock(), _createBlock("button", {
                                        key: 0,
                                        class: "btn default-btn mr-1",
                                        onClick: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.changeInvitePublicMember && _ctx.changeInvitePublicMember(...args)))
                                      }, [
                                        _hoisted_424,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.state.inviteAsPublic &&
                          _ctx.state.inviteAsPublic.length > 1
                        )
                                    ? (_openBlock(), _createBlock("a", {
                                        key: 1,
                                        class: "btn btn-danger",
                                        onClick: ($event: any) => (_ctx.deletePublicMember(publicMember)),
                                        href: "javascript:void(0)"
                                      }, [
                                        _hoisted_425,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                                      ], 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            }), 128)),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.invites, (invite, inviteIndex) => {
                              return (_openBlock(), _createBlock("div", {
                                key: inviteIndex,
                                class: "email-tag"
                              }, [
                                _createVNode("p", _hoisted_426, [
                                  _createTextVNode(_toDisplayString(invite) + " ", 1),
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.removeSelectedUser(invite))
                                  }, [
                                    _hoisted_427,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                                  ], 8, ["onClick"])
                                ])
                              ]))
                            }), 128))
                          ]))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_428, [
              _createVNode("div", null, [
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn secondary-btn mr-2",
                  onClick: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.hideAddMember && _ctx.hideAddMember(...args)))
                }, _toDisplayString(_ctx.$t('cancel')), 1),
                (_ctx.state.data.inviteAsPublicUser)
                  ? (_openBlock(), _createBlock("a", {
                      key: 0,
                      href: "javascript:void(0)",
                      class: "btn default-btn",
                      onClick: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.inviteAllPublicUser && _ctx.inviteAllPublicUser(...args)))
                    }, _toDisplayString(_ctx.$t('send')), 1))
                  : (_openBlock(), _createBlock("a", {
                      key: 1,
                      href: "javascript:void(0)",
                      class: "btn default-btn",
                      onClick: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.inviteAllUsers && _ctx.inviteAllUsers(...args)))
                    }, _toDisplayString(_ctx.state.postLoading.inviteAllUsers ? _ctx.$t('sending') : _ctx.$t('send')), 1))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_429, [
      _createVNode("div", _hoisted_430, [
        _createVNode("div", _hoisted_431, [
          _createVNode("div", _hoisted_432, [
            _createVNode("div", _hoisted_433, [
              _createVNode("div", _hoisted_434, [
                _createVNode("h5", _hoisted_435, _toDisplayString(_ctx.$t('share_project')), 1),
                _createVNode("p", _hoisted_436, _toDisplayString(_ctx.$t('create_project_collaboration')), 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => (_ctx.hideaddShareProject && _ctx.hideaddShareProject(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_437
              ])
            ]),
            _createVNode("div", _hoisted_438, [
              _createVNode("div", _hoisted_439, [
                _createVNode(_component_ErrorList, {
                  errors: _ctx.state.errorList,
                  hasError: _ctx.state.isErrorStatus
                }, null, 8, ["errors", "hasError"]),
                (!_ctx.state.data.invitationProjectVerify.showStatus)
                  ? (_openBlock(), _createBlock("div", _hoisted_440, [
                      _createVNode("div", _hoisted_441, [
                        _createVNode("label", _hoisted_442, _toDisplayString(_ctx.$t('invite_existing_member')), 1),
                        _withDirectives(_createVNode("select", {
                          disabled: _ctx.state.shareProjectUserList && !_ctx.state.shareProjectUserList.length,
                          class: "form-control mb-2",
                          id: "user.id",
                          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (_ctx.state.existingMember = $event)),
                          onChange: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_ctx.changeExistingMember && _ctx.changeExistingMember(...args)))
                        }, [
                          _createVNode("option", _hoisted_443, _toDisplayString(_ctx.$t('select_member')), 1),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.shareProjectUserList, (item, itemIndex) => {
                            return (_openBlock(), _createBlock("option", {
                              value: item,
                              key: itemIndex
                            }, _toDisplayString(item.full_name) + " (" + _toDisplayString(item.email) + ") ", 9, ["value"]))
                          }), 128))
                        ], 40, ["disabled"]), [
                          [_vModelSelect, _ctx.state.existingMember]
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.users, (user, userIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "email-tag",
                            key: userIndex
                          }, [
                            _createVNode("p", _hoisted_444, [
                              _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.email) + ") ", 1),
                              _createVNode("a", {
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                              }, [
                                _hoisted_445
                              ], 8, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ]),
                      _createVNode("div", _hoisted_446, [
                        _createVNode("label", _hoisted_447, _toDisplayString(_ctx.$t('invite_new_member_email')), 1),
                        _createVNode("div", _hoisted_448, [
                          _withDirectives(_createVNode("input", {
                            "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.state.inviteMember = $event)),
                            type: "email",
                            class: "form-control",
                            id: "exampleInputEmail1",
                            "aria-describedby": "emailHelp",
                            placeholder: "Type email and press enter or click add button",
                            onKeyup: _cache[48] || (_cache[48] = _withKeys(
//@ts-ignore
(...args) => (_ctx.changeInviteMember && _ctx.changeInviteMember(...args)), ["enter"]))
                          }, null, 544), [
                            [_vModelText, _ctx.state.inviteMember]
                          ]),
                          _createVNode("button", {
                            class: "btn default-btn w-auto text-white",
                            onClick: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => (_ctx.changeInviteMember && _ctx.changeInviteMember(...args)))
                          }, [
                            _hoisted_449,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
                          ])
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.invites, (invite, inviteIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            key: inviteIndex,
                            class: "email-tag"
                          }, [
                            _createVNode("p", _hoisted_450, [
                              _createTextVNode(_toDisplayString(invite) + " ", 1),
                              _createVNode("a", {
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedUser(invite))
                              }, [
                                _hoisted_451
                              ], 8, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ]),
                      _createVNode("div", _hoisted_452, [
                        _createVNode("label", _hoisted_453, _toDisplayString(_ctx.$t('select_phase')), 1),
                        _createVNode(_component_treeselect, {
                          modelValue: _ctx.state.data.selectSharePhase,
                          "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (_ctx.state.data.selectSharePhase = $event)),
                          "show-count": true,
                          placeholder: _ctx.$t('select_phase_task'),
                          multiple: true,
                          "value-consists-of": _ctx.state.valueConsistsOf,
                          options: _ctx.state.phaseOptions
                        }, null, 8, ["modelValue", "placeholder", "value-consists-of", "options"])
                      ]),
                      _createVNode("div", _hoisted_454, [
                        _createVNode("div", _hoisted_455, [
                          _withDirectives(_createVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            id: "inlineCheckbox2",
                            value: "true",
                            "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_ctx.state.data.invitationProjectVerify.isIndividual = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.state.data.invitationProjectVerify.isIndividual]
                          ]),
                          _createVNode("label", _hoisted_456, _toDisplayString(_ctx.$t('individual_acceptance_required')), 1)
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_457, [
                      (_ctx.state.data.invitationProjectVerify.registeredMemberList &&
                    _ctx.state.data.invitationProjectVerify.registeredMemberList.length
                  )
                        ? (_openBlock(), _createBlock("div", _hoisted_458, [
                            _createVNode("div", _hoisted_459, [
                              _createVNode("p", null, _toDisplayString(_ctx.$t('members_already_active')) + " " + _toDisplayString(_ctx.$t('no_new_invitation')), 1),
                              _createVNode("ul", _hoisted_460, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                          .invitationProjectVerify.registeredMemberList, (regMember, index) => {
                                  return (_openBlock(), _createBlock("li", { key: index }, [
                                    _createVNode("small", null, _toDisplayString(regMember), 1)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.data.invitationProjectVerify.pendingMemberList &&
                    _ctx.state.data.invitationProjectVerify.pendingMemberList.length
                  )
                        ? (_openBlock(), _createBlock("div", _hoisted_461, [
                            _createVNode("div", _hoisted_462, [
                              _createVNode("p", null, [
                                _createVNode("strong", _hoisted_463, _toDisplayString(_ctx.$t('invitations_sent')), 1)
                              ]),
                              _createVNode("ul", _hoisted_464, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                          .invitationProjectVerify.pendingMemberList, (regMember, index) => {
                                  return (_openBlock(), _createBlock("li", { key: index }, [
                                    _createVNode("small", null, _toDisplayString(regMember), 1)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.data.invitationProjectVerify.newMemberList &&
                    _ctx.state.data.invitationProjectVerify.newMemberList.length
                  )
                        ? (_openBlock(), _createBlock("div", _hoisted_465, [
                            _createVNode("div", _hoisted_466, [
                              _createVNode("p", null, [
                                _createVNode("strong", null, _toDisplayString(_ctx.$t('invite_members_below')), 1)
                              ]),
                              _createVNode("ul", _hoisted_467, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                          .invitationProjectVerify.newMemberList, (regMember, index) => {
                                  return (_openBlock(), _createBlock("li", { key: index }, [
                                    _createVNode("p", _hoisted_468, [
                                      _hoisted_469,
                                      _hoisted_470,
                                      _createVNode("small", null, _toDisplayString(regMember.email), 1)
                                    ]),
                                    (regMember.new.length)
                                      ? (_openBlock(), _createBlock("p", _hoisted_471, [
                                          _createVNode("strong", _hoisted_472, _toDisplayString(_ctx.$t('new')) + ": ", 1),
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(regMember.new, (task, taskIndex) => {
                                            return (_openBlock(), _createBlock("span", {
                                              class: "badge bg-primary text-white",
                                              key: taskIndex
                                            }, _toDisplayString(task.name), 1))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (regMember.pending.length)
                                      ? (_openBlock(), _createBlock("p", _hoisted_473, [
                                          _createVNode("strong", _hoisted_474, _toDisplayString(_ctx.$t('pending')) + ": ", 1),
                                          _hoisted_475,
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(regMember.pending, (task, taskIndex) => {
                                            return (_openBlock(), _createBlock("span", {
                                              class: "badge bg-primary text-white",
                                              key: taskIndex
                                            }, _toDisplayString(task.name), 1))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (regMember.shared.length)
                                      ? (_openBlock(), _createBlock("p", _hoisted_476, [
                                          _createVNode("strong", _hoisted_477, _toDisplayString(_ctx.$t('shared')) + ":", 1),
                                          _hoisted_478,
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(regMember.shared, (task, taskIndex) => {
                                            return (_openBlock(), _createBlock("span", {
                                              class: "badge bg-primary text-white",
                                              key: taskIndex
                                            }, _toDisplayString(task.name), 1))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
              ])
            ]),
            _createVNode("div", _hoisted_479, [
              (!_ctx.state.data.invitationProjectVerify.showStatus)
                ? (_openBlock(), _createBlock("a", {
                    key: 0,
                    href: "javascript:void(0)",
                    class: "btn default-btn",
                    onClick: _cache[52] || (_cache[52] = 
//@ts-ignore
(...args) => (_ctx.verifyProjectInvitation && _ctx.verifyProjectInvitation(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.verifyProjectInvitation
                    ? _ctx.$t('inviting')
                    : _ctx.$t('done')), 1))
                : _createCommentVNode("", true),
              (_ctx.state.data.invitationProjectVerify.showStatus)
                ? (_openBlock(), _createBlock("div", _hoisted_480, [
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      class: "btn secondary-btn mr-2",
                      onClick: _cache[53] || (_cache[53] = 
//@ts-ignore
(...args) => (_ctx.backProjectInvitation && _ctx.backProjectInvitation(...args)))
                    }, _toDisplayString(_ctx.$t('back')), 1),
                    ((_ctx.state.data.invitationProjectVerify.newMemberList &&
                  _ctx.state.data.invitationProjectVerify.newMemberList.length) ||
                  (_ctx.state.data.invitationProjectVerify.pendingMemberList &&
                    _ctx.state.data.invitationProjectVerify.pendingMemberList.length)
                )
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          href: "javascript:void(0)",
                          class: "btn default-btn",
                          onClick: _cache[54] || (_cache[54] = 
//@ts-ignore
(...args) => (_ctx.invitationShareProjectPhase && _ctx.invitationShareProjectPhase(...args)))
                        }, _toDisplayString(_ctx.state.postLoading.inviteProjectUsers ? _ctx.$t('sending') : _ctx.$t('send')), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_481, [
      _createVNode("div", _hoisted_482, [
        _createVNode("div", _hoisted_483, [
          (_ctx.state.isLoading.editProjectShare)
            ? (_openBlock(), _createBlock("div", _hoisted_484, [
                _createVNode("img", {
                  src: _ctx.state.data.imageBaseUrl
              ? `${_ctx.state.data.imageBaseUrl}img/loader-spinner.gif`
              : 'img/loader-spinner.gif'
              ,
                  alt: ""
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.state.isLoading.editProjectShare)
            ? (_openBlock(), _createBlock("div", _hoisted_485, [
                _createVNode("div", _hoisted_486, [
                  _createVNode("div", _hoisted_487, [
                    _createVNode("h5", _hoisted_488, _toDisplayString(_ctx.$t('update_share_project')), 1),
                    _createVNode("p", _hoisted_489, _toDisplayString(_ctx.$t('create_project_collaboration')), 1)
                  ]),
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    onClick: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_ctx.hideEditShareProject && _ctx.hideEditShareProject(...args))),
                    "aria-label": "Close"
                  }, [
                    _hoisted_490
                  ])
                ]),
                _createVNode("div", _hoisted_491, [
                  _createVNode("div", _hoisted_492, [
                    _createVNode(_component_ErrorList, {
                      errors: _ctx.state.errorList,
                      hasError: _ctx.state.isErrorStatus
                    }, null, 8, ["errors", "hasError"]),
                    _createVNode("div", null, [
                      _createVNode("div", _hoisted_493, [
                        _createVNode("label", _hoisted_494, _toDisplayString(_ctx.$t('invited_email')), 1),
                        _createVNode("div", _hoisted_495, [
                          _createVNode("p", _hoisted_496, _toDisplayString(_ctx.state.data.invitationProjectEdit.email), 1)
                        ])
                      ]),
                      (_ctx.state.data.invitationProjectEdit.editPhase.length > 0)
                        ? (_openBlock(), _createBlock("div", _hoisted_497, [
                            _createVNode("label", _hoisted_498, _toDisplayString(_ctx.$t('Select Phase')), 1),
                            _createVNode(_component_treeselect, {
                              modelValue: _ctx.state.data.invitationProjectEdit.editPhase,
                              "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => (_ctx.state.data.invitationProjectEdit.editPhase = $event)),
                              "show-count": true,
                              placeholder: _ctx.$t('select_phase_task'),
                              multiple: true,
                              "value-consists-of": _ctx.state.valueConsistsOf,
                              options: _ctx.state.phaseOptions
                            }, null, 8, ["modelValue", "placeholder", "value-consists-of", "options"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.data.invitationProjectEdit.editPhase.length == 0 && _ctx.state.phaseOptions.length > 0 && !_ctx.state.isLoading.editProjectShare)
                        ? (_openBlock(), _createBlock("div", _hoisted_499, [
                            _createVNode("label", _hoisted_500, _toDisplayString(_ctx.$t('select_phase')), 1),
                            _createVNode(_component_treeselect, {
                              modelValue: _ctx.state.data.invitationProjectEdit.editPhase,
                              "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => (_ctx.state.data.invitationProjectEdit.editPhase = $event)),
                              "show-count": true,
                              placeholder: _ctx.$t('select_phase_task'),
                              multiple: true,
                              options: _ctx.state.phaseOptions,
                              "value-consists-of": _ctx.state.valueConsistsOf
                            }, null, 8, ["modelValue", "placeholder", "options", "value-consists-of"])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_501, [
                        _createVNode("div", _hoisted_502, [
                          _withDirectives(_createVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            id: "inlineCheckbox2",
                            value: "true",
                            "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => (_ctx.state.data.invitationProjectEdit.isIndividual = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.state.data.invitationProjectEdit.isIndividual]
                          ]),
                          _createVNode("label", _hoisted_503, _toDisplayString(_ctx.$t('individual_acceptance_required')), 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_504, [
                  (!_ctx.state.data.invitationProjectVerify.showStatus)
                    ? (_openBlock(), _createBlock("a", {
                        key: 0,
                        href: "javascript:void(0)",
                        class: "btn default-btn",
                        onClick: _cache[59] || (_cache[59] = 
//@ts-ignore
(...args) => (_ctx.invitationShareProjectPhaseUpdate && _ctx.invitationShareProjectPhaseUpdate(...args)))
                      }, _toDisplayString(_ctx.state.ui.isPostLoading.verifyProjectInvitation
                    ? _ctx.$t('update_inviting1')
                    : _ctx.$t('update')), 1))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.invitationProjectVerify.showStatus)
                    ? (_openBlock(), _createBlock("div", _hoisted_505, [
                        _createVNode("a", {
                          href: "javascript:void(0)",
                          class: "btn secondary-btn mr-2",
                          onClick: _cache[60] || (_cache[60] = 
//@ts-ignore
(...args) => (_ctx.backProjectInvitation && _ctx.backProjectInvitation(...args)))
                        }, "Back"),
                        ((_ctx.state.data.invitationProjectVerify.newMemberList &&
                  _ctx.state.data.invitationProjectVerify.newMemberList.length) ||
                  (_ctx.state.data.invitationProjectVerify.pendingMemberList &&
                    _ctx.state.data.invitationProjectVerify.pendingMemberList.length)
                )
                          ? (_openBlock(), _createBlock("a", {
                              key: 0,
                              href: "javascript:void(0)",
                              class: "btn default-btn",
                              onClick: _cache[61] || (_cache[61] = 
//@ts-ignore
(...args) => (_ctx.invitationShareProjectPhase && _ctx.invitationShareProjectPhase(...args)))
                            }, _toDisplayString(_ctx.state.postLoading.inviteProjectUsers ? _ctx.$t('sending') : _ctx.$t('send')), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_506, [
      _createVNode("div", _hoisted_507, [
        _createVNode("div", _hoisted_508, [
          _createVNode("div", _hoisted_509, [
            _createVNode("div", _hoisted_510, [
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[62] || (_cache[62] = 
//@ts-ignore
(...args) => (_ctx.hideSuccessInvitationModal && _ctx.hideSuccessInvitationModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_511
              ]),
              _hoisted_512
            ]),
            _createVNode("div", _hoisted_513, [
              _createVNode("h3", null, _toDisplayString(_ctx.$t('great')), 1),
              _createVNode("p", null, _toDisplayString(_ctx.state.invitationMessage), 1),
              _createVNode("p", null, _toDisplayString(_ctx.$t('go_to_channels')), 1)
            ]),
            _createVNode("div", _hoisted_514, [
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn default-btn outline",
                onClick: _cache[63] || (_cache[63] = 
//@ts-ignore
(...args) => (_ctx.addMember && _ctx.addMember(...args)))
              }, _toDisplayString(_ctx.$t('invite_more_people')), 1),
              _createVNode("a", {
                href: "javascript:void(0)",
                onClick: _cache[64] || (_cache[64] = 
//@ts-ignore
(...args) => (_ctx.hideSuccessInvitationModal && _ctx.hideSuccessInvitationModal(...args))),
                class: "btn default-btn outline danger to-upper",
                "data-dismiss": "modal"
              }, _toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_515, [
      _createVNode("div", _hoisted_516, [
        _createVNode("div", _hoisted_517, [
          _createVNode("div", _hoisted_518, [
            _createVNode("div", _hoisted_519, [
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[65] || (_cache[65] = 
//@ts-ignore
(...args) => (_ctx.hideSuccessInvitationModal && _ctx.hideSuccessInvitationModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_520
              ]),
              _hoisted_521
            ]),
            _createVNode("div", _hoisted_522, [
              _createVNode("h3", null, _toDisplayString(_ctx.$t('great')), 1),
              _createVNode("p", null, _toDisplayString(_ctx.state.invitationMessage), 1)
            ]),
            _createVNode("div", _hoisted_523, [
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn default-btn outline",
                onClick: _cache[66] || (_cache[66] = 
//@ts-ignore
(...args) => (_ctx.addShareProject && _ctx.addShareProject(...args)))
              }, _toDisplayString(_ctx.$t('invite_more_people')), 1),
              _createVNode("a", {
                href: "javascript:void(0)",
                onClick: _cache[67] || (_cache[67] = 
//@ts-ignore
(...args) => (_ctx.hideSuccessInvitationModal && _ctx.hideSuccessInvitationModal(...args))),
                class: "btn default-btn outline danger to-upper",
                "data-dismiss": "modal"
              }, _toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_524, [
      _createVNode("div", _hoisted_525, [
        _createVNode("div", _hoisted_526, [
          _createVNode("div", _hoisted_527, [
            _createVNode("div", _hoisted_528, [
              _createVNode("h5", _hoisted_529, _toDisplayString(_ctx.$t('project_acknowledgment_request')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[68] || (_cache[68] = 
//@ts-ignore
(...args) => (_ctx.hideProjectAcknowledgementRequestDetails && _ctx.hideProjectAcknowledgementRequestDetails(...args)))
              }, [
                _hoisted_530
              ])
            ]),
            _createVNode("div", _hoisted_531, [
              _createVNode("div", _hoisted_532, [
                _createVNode("div", _hoisted_533, [
                  (_ctx.state.projectDetail.approval &&
                    _ctx.state.projectDetail.approval.payers &&
                    _ctx.state.projectDetail.approval.payers.length
                  )
                    ? (_openBlock(), _createBlock("div", _hoisted_534, [
                        _createVNode("div", _hoisted_535, [
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('payer_email')) + " :", 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_536, [
                          _createVNode("div", _hoisted_537, [
                            _createVNode("ul", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.projectDetail
                            .approval.payers, (payer, payerIndex) => {
                                return (_openBlock(), _createBlock("li", { key: payerIndex }, [
                                  (payer.user && payer.user.full_name)
                                    ? (_openBlock(), _createBlock("span", _hoisted_538, _toDisplayString(payer.user.full_name), 1))
                                    : _createCommentVNode("", true),
                                  (payer.user && payer.user.email)
                                    ? (_openBlock(), _createBlock("span", _hoisted_539, "(" + _toDisplayString(payer.user.email) + ")", 1))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_540, [
                  _createVNode("p", _hoisted_541, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t('estimated_budget')) + " :", 1)
                  ]),
                  (_ctx.state.projectDetail.approval &&
                    _ctx.state.projectDetail.approval.payerRequest &&
                    _ctx.state.projectDetail.approval.payerRequest.budget
                  )
                    ? (_openBlock(), _createBlock("p", _hoisted_542, _toDisplayString(_ctx.state.projectDetail.approval.payerRequest.budget), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_543, [
                  _createVNode("p", null, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t('attachments')) + " :", 1)
                  ]),
                  _createVNode("ul", null, [
                    _createVNode("li", null, [
                      (_ctx.state.projectDetail.approval &&
                        _ctx.state.projectDetail.approval.attachments &&
                        _ctx.state.projectDetail.approval.attachments.length
                      )
                        ? (_openBlock(), _createBlock(_component_ToDoDetailsAttachment, {
                            key: 0,
                            todoAttachments: _ctx.state.projectDetail.approval.attachments
                        
                          }, null, 8, ["todoAttachments"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_544, [
                  _createVNode("p", _hoisted_545, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t('edoc_link')) + " :", 1)
                  ]),
                  (_ctx.state.projectDetail.approval &&
                    _ctx.state.projectDetail.approval.payerRequest &&
                    _ctx.state.projectDetail.approval.payerRequest.edoc_id
                  )
                    ? (_openBlock(), _createBlock("p", _hoisted_546, [
                        _createVNode("a", {
                          href: "javascript:void(0)",
                          class: "link-primary",
                          onClick: _cache[69] || (_cache[69] = ($event: any) => (
                      _ctx.redirectToDoc(
                        _ctx.state.projectDetail.approval.payerRequest.edoc_id
                      )
                      ))
                        }, _toDisplayString(_ctx.state.projectDetail.approval.payerRequest.edoc_id), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_547, [
                  _createVNode("p", _hoisted_548, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t('history')) + " :", 1)
                  ]),
                  (_ctx.state.projectDetail.approval &&
                    _ctx.state.projectDetail.approval.history &&
                    _ctx.state.projectDetail.approval.history.length
                  )
                    ? (_openBlock(), _createBlock("div", _hoisted_549, [
                        _createVNode("div", _hoisted_550, [
                          _createVNode("table", _hoisted_551, [
                            _createVNode("thead", _hoisted_552, [
                              _createVNode("tr", null, [
                                _createVNode("td", _hoisted_553, _toDisplayString(_ctx.$t('budget')), 1),
                                _createVNode("td", null, _toDisplayString(_ctx.$t('start_date1')), 1),
                                _createVNode("td", null, _toDisplayString(_ctx.$t('end_date1')), 1),
                                _createVNode("td", null, _toDisplayString(_ctx.$t('edoc_link')), 1)
                              ])
                            ]),
                            _createVNode("tbody", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.projectDetail
                            .approval.history, (phase, phaseIndex) => {
                                return (_openBlock(), _createBlock("tr", { key: phaseIndex }, [
                                  _createVNode("td", null, [
                                    _createVNode("strong", null, [
                                      _createVNode("a", _hoisted_554, _toDisplayString(phase.payerRequest.budget), 1)
                                    ])
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("p", null, _toDisplayString(phase.payerRequest.start_date), 1)
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("p", null, _toDisplayString(phase.payerRequest.end_date), 1)
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("p", null, _toDisplayString(phase.payerRequest.edoc_id), 1)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_555, [
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn default-btn",
                onClick: _cache[70] || (_cache[70] = 
//@ts-ignore
(...args) => (_ctx.resendProjectRequest && _ctx.resendProjectRequest(...args)))
              }, _toDisplayString(_ctx.$t('send_request')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn to-upper",
                "data-dismiss": "modal",
                onClick: _cache[71] || (_cache[71] = 
//@ts-ignore
(...args) => (_ctx.hideProjectAcknowledgementRequestDetails && _ctx.hideProjectAcknowledgementRequestDetails(...args)))
              }, _toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_556, [
      _createVNode("div", _hoisted_557, [
        _createVNode("div", _hoisted_558, [
          _createVNode("div", _hoisted_559, [
            _createVNode("div", _hoisted_560, [
              _createVNode("h5", _hoisted_561, _toDisplayString(_ctx.$t('pending_member')), 1),
              _hoisted_562
            ]),
            (_ctx.state.pendingList && _ctx.state.pendingList.length)
              ? (_openBlock(), _createBlock("div", _hoisted_563, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.pendingList, (pendUser, pendUserIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "row align-items-center",
                      key: pendUserIndex
                    }, [
                      _createVNode("div", _hoisted_564, [
                        _createVNode("div", _hoisted_565, [
                          _hoisted_566,
                          _createVNode("p", _hoisted_567, _toDisplayString(pendUser.email), 1)
                        ])
                      ]),
                      _createVNode("div", _hoisted_568, [
                        _createVNode("a", _hoisted_569, [
                          _hoisted_570,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('resend')), 1)
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_571, [
                  _createVNode(_component_EmptyData, {
                    title: _ctx.state.titleMember,
                    heading: _ctx.state.headingMember
                  }, null, 8, ["title", "heading"])
                ])),
            _createVNode("div", _hoisted_572, [
              _createVNode("button", _hoisted_573, _toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_574, [
      _createVNode("div", _hoisted_575, [
        _createVNode("div", _hoisted_576, [
          _createVNode("div", _hoisted_577, [
            _createVNode("div", _hoisted_578, [
              _createVNode("h5", _hoisted_579, _toDisplayString(_ctx.$t('change_role')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[72] || (_cache[72] = 
//@ts-ignore
(...args) => (_ctx.hideUserProfile && _ctx.hideUserProfile(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_580
              ])
            ]),
            _createVNode("div", _hoisted_581, [
              (_ctx.state.selectedMember)
                ? (_openBlock(), _createBlock("div", _hoisted_582, [
                    (_ctx.state.selectedMember.user)
                      ? (_openBlock(), _createBlock("div", _hoisted_583, [
                          _createVNode("img", {
                            src: _ctx.state.selectedMember.user.image,
                            alt: ""
                          }, null, 8, ["src"])
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_584, [
                          _hoisted_585
                        ])),
                    (_ctx.state.selectedMember.user &&
                  _ctx.state.selectedMember.user.full_name
                )
                      ? (_openBlock(), _createBlock("h5", _hoisted_586, _toDisplayString(_ctx.state.selectedMember.user.full_name), 1))
                      : _createCommentVNode("", true),
                    (_ctx.state.selectedMember.user)
                      ? (_openBlock(), _createBlock("p", _hoisted_587, [
                          _hoisted_588,
                          _createTextVNode(" " + _toDisplayString(_ctx.state.selectedMember.user.email), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_589, [
                (_ctx.state.selectedMember.created_by &&
                  _ctx.state.selectedMember.created_by.full_name
                )
                  ? (_openBlock(), _createBlock("p", _hoisted_590, _toDisplayString(_ctx.$t('added_by')) + " " + _toDisplayString(_ctx.state.selectedMember.created_by.full_name) + " " + _toDisplayString(_ctx.$t('on')) + " " + _toDisplayString(_ctx.state.selectedMember.created_date), 1))
                  : _createCommentVNode("", true),
                (_ctx.state.selectedMember.project_role)
                  ? (_openBlock(), _createBlock("div", _hoisted_591, [
                      _createVNode("label", _hoisted_592, _toDisplayString(_ctx.$t('role')), 1),
                      _withDirectives(_createVNode("select", {
                        class: "form-control custom-select",
                        "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => (_ctx.state.selectedMemberRole = $event)),
                        onChange: _cache[74] || (_cache[74] = 
//@ts-ignore
(...args) => (_ctx.selectRole && _ctx.selectRole(...args)))
                      }, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.roleList, (role, roleIndex) => {
                          return (_openBlock(), _createBlock("option", {
                            value: role.id,
                            key: roleIndex
                          }, _toDisplayString(role.name), 9, ["value"]))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, _ctx.state.selectedMemberRole]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.selectedMemberRole === 2 || _ctx.state.selectedMemberRole === 3)
                  ? (_openBlock(), _createBlock("div", _hoisted_593, [
                      _createVNode("label", _hoisted_594, [
                        _createTextVNode(_toDisplayString(_ctx.$t('channel_list')) + " ", 1),
                        _hoisted_595
                      ]),
                      _hoisted_596,
                      _createVNode("div", _hoisted_597, [
                        _createVNode("ul", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.allCreatedChannel, (channel, channelIndex) => {
                            return (_openBlock(), _createBlock("li", { key: channelIndex }, [
                              _createVNode("div", _hoisted_598, [
                                _withDirectives(_createVNode("input", {
                                  id: 'customCheck1' + channelIndex,
                                  class: "custom-control-input",
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => (channel.isChecked = $event),
                                  value: channel.id,
                                  onClick: ($event: any) => (_ctx.changeChannelCheckBox(channel))
                                }, null, 8, ["id", "onUpdate:modelValue", "value", "onClick"]), [
                                  [_vModelCheckbox, channel.isChecked]
                                ]),
                                _createVNode("label", {
                                  class: "custom-control-label",
                                  for: 'customCheck1' + channelIndex
                                }, _toDisplayString(channel.name), 9, ["for"])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.selectedMemberRole === 4)
                  ? (_openBlock(), _createBlock("div", _hoisted_599, [
                      _createVNode("label", _hoisted_600, _toDisplayString(_ctx.$t('validity')), 1),
                      _createVNode(_component_v_date_picker, {
                        class: "inline-block h-full",
                        modelValue: _ctx.state.data.selectedValidityDate,
                        "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => (_ctx.state.data.selectedValidityDate = $event))
                      }, {
                        default: _withCtx(({ inputValue, togglePopover }) => [
                          _createVNode("div", _hoisted_601, [
                            _createVNode("button", {
                              class: "bg-green p-2",
                              onClick: ($event: any) => (togglePopover())
                            }, [
                              _hoisted_602
                            ], 8, ["onClick"]),
                            _createVNode("input", {
                              value: inputValue,
                              class: "form-control",
                              readonly: ""
                            }, null, 8, ["value"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.state.selectedMemberRole != 2 && _ctx.state.selectedMemberRole != 3)
                ? (_openBlock(), _createBlock("div", _hoisted_603, [
                    (_ctx.state.selectedMemberRole != 4)
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          href: "javascript:void(0)",
                          class: "btn default-btn",
                          onClick: _cache[76] || (_cache[76] = 
//@ts-ignore
(...args) => (_ctx.changeProjectRole && _ctx.changeProjectRole(...args)))
                        }, _toDisplayString(_ctx.state.postLoading.changeProjectRole
                      ? _ctx.$t('changing')
                      : _ctx.$t('save_changes')), 1))
                      : _createCommentVNode("", true),
                    (_ctx.state.selectedMemberRole === 4)
                      ? (_openBlock(), _createBlock("a", {
                          key: 1,
                          href: "javascript:void(0)",
                          class: "btn default-btn",
                          onClick: _cache[77] || (_cache[77] = 
//@ts-ignore
(...args) => (_ctx.setNewValidity && _ctx.setNewValidity(...args)))
                        }, _toDisplayString(_ctx.state.ui.postLoading.setNewValidity
                      ? _ctx.$t('changing')
                      : _ctx.$t('change_validity')), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_604, [
      _createVNode("div", _hoisted_605, [
        _createVNode("div", _hoisted_606, [
          (_ctx.state.selectedMemberForRemoval.user)
            ? (_openBlock(), _createBlock("div", _hoisted_607, [
                _createVNode("div", _hoisted_608, [
                  (_ctx.state.selectedMemberForRemoval.user &&
                _ctx.state.selectedMemberForRemoval.user.full_name
              )
                    ? (_openBlock(), _createBlock("h5", _hoisted_609, _toDisplayString(_ctx.$t('remove')) + " " + _toDisplayString(_ctx.state.selectedMemberForRemoval.user.full_name) + " ? ", 1))
                    : _createCommentVNode("", true),
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    "aria-label": "Close",
                    onClick: _cache[78] || (_cache[78] = 
//@ts-ignore
(...args) => (_ctx.hideProjectMemberRemove && _ctx.hideProjectMemberRemove(...args)))
                  }, [
                    _hoisted_610
                  ])
                ]),
                _createVNode("div", _hoisted_611, [
                  _createVNode(_component_ErrorList, {
                    errors: _ctx.state.ui.errors.errorList.removeProjectRole,
                    hasError: _ctx.state.ui.errors.hasError
                  }, null, 8, ["errors", "hasError"]),
                  _createVNode("p", null, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t('removing_user_notice')) + ":", 1)
                  ]),
                  _createVNode("div", _hoisted_612, [
                    _createVNode("ul", null, [
                      (_ctx.state.selectedMemberForRemoval.user &&
                    _ctx.state.selectedMemberForRemoval.user.full_name
                  )
                        ? (_openBlock(), _createBlock("li", _hoisted_613, _toDisplayString(_ctx.state.selectedMemberForRemoval.user.full_name) + " " + _toDisplayString(_ctx.$t('will_be_removed_them_from_this_project')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.state.selectedMemberForRemoval.user &&
                    _ctx.state.selectedMemberForRemoval.user.full_name
                  )
                        ? (_openBlock(), _createBlock("li", _hoisted_614, _toDisplayString(_ctx.state.selectedMemberForRemoval.user.full_name) + " " + _toDisplayString(_ctx.$t('user_no_activity')), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_615, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn secondary-btn to-upper",
                    onClick: _cache[79] || (_cache[79] = 
//@ts-ignore
(...args) => (_ctx.hideProjectMemberRemove && _ctx.hideProjectMemberRemove(...args)))
                  }, _toDisplayString(_ctx.$t('cancel')), 1),
                  _createVNode("button", {
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[80] || (_cache[80] = 
//@ts-ignore
(...args) => (_ctx.removeProjectRole && _ctx.removeProjectRole(...args)))
                  }, _toDisplayString(_ctx.state.postLoading.removeProjectRole
                    ? _ctx.$t('removing')
                    : _ctx.$t('yes_remove_user')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_616, [
      _createVNode("div", _hoisted_617, [
        _createVNode("div", _hoisted_618, [
          _createVNode("div", _hoisted_619, [
            _createVNode("div", _hoisted_620, [
              _createVNode("h5", _hoisted_621, _toDisplayString(_ctx.$t('member')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[81] || (_cache[81] = 
//@ts-ignore
(...args) => (_ctx.hideMemberModal && _ctx.hideMemberModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_622
              ])
            ]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.memberList, (member, memberIndex) => {
              return (_openBlock(), _createBlock("div", {
                class: "modal-body",
                key: memberIndex
              }, [
                (!_ctx.state.projectDetail.deleted_at && !member.deleted_at)
                  ? (_openBlock(), _createBlock("div", _hoisted_623, [
                      _createVNode("div", _hoisted_624, [
                        (member.user && member.user.image)
                          ? (_openBlock(), _createBlock("img", {
                              key: 0,
                              src: member.user.image,
                              alt: ""
                            }, null, 8, ["src"]))
                          : (_openBlock(), _createBlock("img", {
                              key: 1,
                              src: _ctx.state.data.imageBaseUrl
                    ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                    : 'img/no-user.jpg'
                    ,
                              alt: ""
                            }, null, 8, ["src"]))
                      ]),
                      (member.user && member.user.email)
                        ? (_openBlock(), _createBlock("p", _hoisted_625, _toDisplayString(member.user.email), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (_ctx.state.projectDetail.deleted_at && member.deleted_at)
                    ? (_openBlock(), _createBlock("div", _hoisted_626, [
                        _createVNode("div", _hoisted_627, [
                          (member.user && member.user.image)
                            ? (_openBlock(), _createBlock("img", {
                                key: 0,
                                src: member.user.image,
                                alt: ""
                              }, null, 8, ["src"]))
                            : (_openBlock(), _createBlock("img", {
                                key: 1,
                                src: _ctx.state.data.imageBaseUrl
                    ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                    : 'img/no-user.jpg'
                    ,
                                alt: ""
                              }, null, 8, ["src"]))
                        ]),
                        (member.user && member.user.email)
                          ? (_openBlock(), _createBlock("p", _hoisted_628, _toDisplayString(member.user.email), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
              ]))
            }), 128)),
            _createVNode("div", _hoisted_629, [
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn to-upper",
                "data-dismiss": "modal",
                onClick: _cache[82] || (_cache[82] = 
//@ts-ignore
(...args) => (_ctx.hideMemberModal && _ctx.hideMemberModal(...args)))
              }, _toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_630, [
      _createVNode("div", _hoisted_631, [
        _createVNode("div", _hoisted_632, [
          _createVNode("div", _hoisted_633, [
            _createVNode("div", _hoisted_634, [
              _createVNode("h5", _hoisted_635, _toDisplayString(_ctx.$t('pending_members')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[83] || (_cache[83] = 
//@ts-ignore
(...args) => (_ctx.hidePendingMemberModal && _ctx.hidePendingMemberModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_636
              ])
            ]),
            (_ctx.state.data.pendingList && _ctx.state.data.pendingList.length)
              ? (_openBlock(), _createBlock("div", _hoisted_637, [
                  _createVNode(_component_ErrorList, {
                    errors: _ctx.state.ui.errors.errorList.resendInvitation,
                    hasError: _ctx.state.ui.errors.hasError
                  }, null, 8, ["errors", "hasError"]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.pendingList, (member, pendingMemberIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "row align-items-center",
                      key: pendingMemberIndex
                    }, [
                      _createVNode("div", _hoisted_638, [
                        _createVNode("div", _hoisted_639, [
                          _createVNode("div", _hoisted_640, [
                            (member.user && member.user.image)
                              ? (_openBlock(), _createBlock("img", {
                                  key: 0,
                                  src: member.user.image,
                                  alt: ""
                                }, null, 8, ["src"]))
                              : (_openBlock(), _createBlock("img", {
                                  key: 1,
                                  src: _ctx.state.data.imageBaseUrl
                        ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                        : 'img/no-user.jpg'
                        ,
                                  alt: ""
                                }, null, 8, ["src"]))
                          ]),
                          (member && member.contact_number)
                            ? (_openBlock(), _createBlock("p", _hoisted_641, _toDisplayString(member.contact_number), 1))
                            : _createCommentVNode("", true),
                          (member && member.email)
                            ? (_openBlock(), _createBlock("p", _hoisted_642, _toDisplayString(member.email), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (_ctx.isUserStatus && member.statusCode === 'active')
                        ? (_openBlock(), _createBlock("div", _hoisted_643, [
                            _createVNode("a", {
                              class: "btn default-btn outline orange p-1 mr-2 to-upper",
                              href: "javascript:void(0)",
                              onClick: ($event: any) => (_ctx.selectPendingMemberForDeletes(member))
                            }, [
                              _createVNode("small", null, [
                                _hoisted_644,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                              ])
                            ], 8, ["onClick"]),
                            _createVNode("a", {
                              class: "btn default-btn outline p-1",
                              href: "javascript:void(0)",
                              onClick: ($event: any) => (_ctx.showResendInvitationConfirmation(member))
                            }, [
                              _createVNode("small", null, [
                                _hoisted_645,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('resend')), 1)
                              ])
                            ], 8, ["onClick"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_646, [
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn to-upper",
                "data-dismiss": "modal",
                onClick: _cache[84] || (_cache[84] = 
//@ts-ignore
(...args) => (_ctx.hidePendingMemberModal && _ctx.hidePendingMemberModal(...args)))
              }, _toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_647, [
      _createVNode("div", _hoisted_648, [
        _createVNode("div", _hoisted_649, [
          (_ctx.state.data.selectedPendingMember)
            ? (_openBlock(), _createBlock("div", _hoisted_650, [
                _createVNode("div", _hoisted_651, [
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    "aria-label": "Close",
                    onClick: _cache[85] || (_cache[85] = 
//@ts-ignore
(...args) => (_ctx.hideHistoryMember && _ctx.hideHistoryMember(...args)))
                  }, [
                    _hoisted_652
                  ])
                ]),
                _createVNode("div", _hoisted_653, [
                  _hoisted_654,
                  _hoisted_655,
                  _createVNode("div", _hoisted_656, [
                    _createVNode("label", null, [
                      _withDirectives(_createVNode("input", {
                        type: "radio",
                        name: "fruit",
                        value: "1",
                        "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => (_ctx.selectedValueForPending = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.selectedValueForPending]
                      ]),
                      _hoisted_657
                    ]),
                    _hoisted_658,
                    _createVNode("label", null, [
                      _withDirectives(_createVNode("input", {
                        type: "radio",
                        name: "fruit",
                        value: "2",
                        "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => (_ctx.selectedValueForPending = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.selectedValueForPending]
                      ]),
                      _hoisted_659
                    ]),
                    _hoisted_660,
                    _createVNode("label", null, [
                      _withDirectives(_createVNode("input", {
                        type: "radio",
                        name: "fruit",
                        value: "3",
                        "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => (_ctx.selectedValueForPending = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.selectedValueForPending]
                      ]),
                      _hoisted_661
                    ]),
                    _hoisted_662,
                    _createVNode("label", null, [
                      _withDirectives(_createVNode("input", {
                        type: "radio",
                        name: "fruit",
                        value: "4",
                        "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event: any) => (_ctx.selectedValueForPending = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.selectedValueForPending]
                      ]),
                      _hoisted_663
                    ]),
                    _hoisted_664
                  ]),
                  (_ctx.selectedValueForPending === '4')
                    ? (_openBlock(), _createBlock("div", _hoisted_665, [
                        _createVNode("div", _hoisted_666, [
                          _createVNode("div", _hoisted_667, [
                            _createVNode(_component_v_date_picker, {
                              modelValue: _ctx.selectedDateForMember,
                              "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => (_ctx.selectedDateForMember = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_668, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn secondary-btn",
                    onClick: _cache[91] || (_cache[91] = 
//@ts-ignore
(...args) => (_ctx.hideHistoryMember && _ctx.hideHistoryMember(...args)))
                  }, " Cancel "),
                  _createVNode("button", {
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[92] || (_cache[92] = 
//@ts-ignore
(...args) => (_ctx.modifyHistoryDateForMember && _ctx.modifyHistoryDateForMember(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.deletePendingInvitation
                    ? "Loading..."
                    : "Modify"), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_669, [
      _createVNode("div", _hoisted_670, [
        _createVNode("div", _hoisted_671, [
          (_ctx.state.data.selectedPendingMember)
            ? (_openBlock(), _createBlock("div", _hoisted_672, [
                _createVNode("div", _hoisted_673, [
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    "aria-label": "Close",
                    onClick: _cache[93] || (_cache[93] = 
//@ts-ignore
(...args) => (_ctx.hidePendingMemberRemove && _ctx.hidePendingMemberRemove(...args)))
                  }, [
                    _hoisted_674
                  ])
                ]),
                (_ctx.state.data.selectedPendingMember.email)
                  ? (_openBlock(), _createBlock("div", _hoisted_675, [
                      _createVNode("div", _hoisted_676, [
                        (_ctx.state.data.selectedPendingMember)
                          ? (_openBlock(), _createBlock("p", _hoisted_677, [
                              _createTextVNode(_toDisplayString(_ctx.$t('are_you_sure_remove')) + " ", 1),
                              _createVNode("strong", null, _toDisplayString(_ctx.state.data.selectedPendingMember.email), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_678, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn secondary-btn to-upper",
                    onClick: _cache[94] || (_cache[94] = 
//@ts-ignore
(...args) => (_ctx.hidePendingMemberRemove && _ctx.hidePendingMemberRemove(...args)))
                  }, _toDisplayString(_ctx.$t('cancel')), 1),
                  _createVNode("button", {
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[95] || (_cache[95] = 
//@ts-ignore
(...args) => (_ctx.deletePendingInvitation && _ctx.deletePendingInvitation(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.deletePendingInvitation
                    ? _ctx.$t('removing')
                    : _ctx.$t('yes_remove_user')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_679, [
      _createVNode("div", _hoisted_680, [
        _createVNode("div", _hoisted_681, [
          (_ctx.state.data.selectedPendingMember)
            ? (_openBlock(), _createBlock("div", _hoisted_682, [
                _createVNode("div", _hoisted_683, [
                  (_ctx.state.data.selectedPendingMember)
                    ? (_openBlock(), _createBlock("h5", _hoisted_684, _toDisplayString(_ctx.$t('reinvite')) + " " + _toDisplayString(_ctx.state.data.selectedPendingMember.email) + "? ", 1))
                    : _createCommentVNode("", true),
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    "aria-label": "Close",
                    onClick: _cache[96] || (_cache[96] = 
//@ts-ignore
(...args) => (_ctx.hideResendInvitationConfirmation && _ctx.hideResendInvitationConfirmation(...args)))
                  }, [
                    _hoisted_685
                  ])
                ]),
                (_ctx.state.data.selectedPendingMember.email)
                  ? (_openBlock(), _createBlock("div", _hoisted_686, [
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('reinviting_user_will')) + ":", 1)
                      ]),
                      _createVNode("div", _hoisted_687, [
                        _createVNode("ul", null, [
                          _createVNode("li", null, _toDisplayString(_ctx.state.data.selectedPendingMember.email) + " " + _toDisplayString(_ctx.$t('will_be_invited_again')), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_688, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn secondary-btn to-upper",
                    onClick: _cache[97] || (_cache[97] = 
//@ts-ignore
(...args) => (_ctx.hideResendInvitationConfirmation && _ctx.hideResendInvitationConfirmation(...args)))
                  }, _toDisplayString(_ctx.$t('cancel')), 1),
                  _createVNode("button", {
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[98] || (_cache[98] = 
//@ts-ignore
(...args) => (_ctx.resendInvitation && _ctx.resendInvitation(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.resendInvitation
                    ? _ctx.$t('reinviting')
                    : _ctx.$t('yes_invite_user')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_689, [
      _createVNode("div", _hoisted_690, [
        _createVNode("div", _hoisted_691, [
          _createVNode("div", _hoisted_692, [
            _createVNode("div", _hoisted_693, [
              _createVNode("h5", _hoisted_694, _toDisplayString(_ctx.$t('edit_channel')) + " : " + _toDisplayString(_ctx.state.data.selectedChannel.name), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[99] || (_cache[99] = 
//@ts-ignore
(...args) => (_ctx.hideEditChannelModal && _ctx.hideEditChannelModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_695
              ])
            ]),
            _createVNode("div", _hoisted_696, [
              _createVNode("div", _hoisted_697, [
                _createVNode(_component_ErrorList, {
                  errors: _ctx.state.ui.errors.errorList.saveEditChannel,
                  hasError: _ctx.state.ui.errors.hasError
                }, null, 8, ["errors", "hasError"])
              ]),
              _createVNode("div", _hoisted_698, [
                _createVNode("label", _hoisted_699, [
                  _createTextVNode(_toDisplayString(_ctx.$t('channel_name')) + " ", 1),
                  _hoisted_700
                ]),
                _withDirectives(_createVNode("input", {
                  type: "input",
                  class: "form-control",
                  id: "exampleInput",
                  "aria-describedby": "emailHelp",
                  placeholder: _ctx.$t('channel_name'),
                  "onUpdate:modelValue": _cache[100] || (_cache[100] = ($event: any) => (_ctx.state.data.selectedEditChannel.name = $event))
                }, null, 8, ["placeholder"]), [
                  [_vModelText, _ctx.state.data.selectedEditChannel.name]
                ])
              ]),
              _createVNode("div", _hoisted_701, [
                _createVNode("label", _hoisted_702, _toDisplayString(_ctx.$t('channel_description1')), 1),
                _withDirectives(_createVNode("textarea", {
                  class: "form-control",
                  name: "",
                  id: "",
                  cols: "30",
                  rows: "5",
                  placeholder: _ctx.$t('describe_channel'),
                  "onUpdate:modelValue": _cache[101] || (_cache[101] = ($event: any) => (_ctx.state.data.selectedEditChannel.description = $event))
                }, null, 8, ["placeholder"]), [
                  [_vModelText, _ctx.state.data.selectedEditChannel.description]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_703, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[102] || (_cache[102] = 
//@ts-ignore
(...args) => (_ctx.saveEditChannel && _ctx.saveEditChannel(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.saveEditChannel
                    ? _ctx.$t('loading1')
                    : _ctx.$t('save_changes')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn to-upper",
                "data-dismiss": "modal",
                onClick: _cache[103] || (_cache[103] = 
//@ts-ignore
(...args) => (_ctx.hideEditChannelModal && _ctx.hideEditChannelModal(...args)))
              }, _toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_704, [
      _createVNode("div", _hoisted_705, [
        _createVNode("div", _hoisted_706, [
          _createVNode("div", _hoisted_707, [
            _createVNode("div", _hoisted_708, [
              _createVNode("div", _hoisted_709, [
                _createVNode("h5", _hoisted_710, _toDisplayString(_ctx.$t('create_todo')), 1),
                _createVNode("p", _hoisted_711, _toDisplayString(_ctx.$t('add_payers_email_to_todo')), 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[104] || (_cache[104] = 
//@ts-ignore
(...args) => (_ctx.hideCreateToDoModal && _ctx.hideCreateToDoModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_712
              ])
            ]),
            _createVNode("div", _hoisted_713, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.errors.errorList.createToDo,
                hasError: _ctx.state.ui.errors.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_714, [
                _createVNode("div", _hoisted_715, [
                  _createVNode("label", _hoisted_716, _toDisplayString(_ctx.$t('payers_email')), 1),
                  _withDirectives(_createVNode("input", {
                    type: "email",
                    class: "form-control",
                    id: "exampleInputEmail1",
                    "aria-describedby": "emailHelp",
                    placeholder: 'eg.payer@convorally.com: ' + _ctx.$t('member_exists'),
                    "onUpdate:modelValue": _cache[105] || (_cache[105] = ($event: any) => (_ctx.state.data.todo.payerEmail = $event))
                  }, null, 8, ["placeholder"]), [
                    [_vModelText, _ctx.state.data.todo.payerEmail]
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_717, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[106] || (_cache[106] = 
//@ts-ignore
(...args) => (_ctx.createProjectToDo && _ctx.createProjectToDo(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.createProjectToDo
                    ? _ctx.$t('loading1')
                    : _ctx.$t('create_todo')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_718, [
      _createVNode("div", _hoisted_719, [
        _createVNode("div", _hoisted_720, [
          (_ctx.state.selectedShareInvitationForRemoval)
            ? (_openBlock(), _createBlock("div", _hoisted_721, [
                _createVNode("div", _hoisted_722, [
                  (_ctx.state.selectedShareInvitationForRemoval &&
                _ctx.state.selectedShareInvitationForRemoval.email
              )
                    ? (_openBlock(), _createBlock("h5", _hoisted_723, _toDisplayString(_ctx.$t('remove')) + " " + _toDisplayString(_ctx.state.selectedShareInvitationForRemoval.email) + " ? ", 1))
                    : _createCommentVNode("", true),
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    "aria-label": "Close",
                    onClick: _cache[107] || (_cache[107] = 
//@ts-ignore
(...args) => (_ctx.hideShareProjectRemove && _ctx.hideShareProjectRemove(...args)))
                  }, [
                    _hoisted_724
                  ])
                ]),
                _createVNode("div", _hoisted_725, [
                  _createVNode(_component_ErrorList, {
                    errors: _ctx.state.ui.errors.errorList.removeProjectRole,
                    hasError: _ctx.state.ui.errors.hasError
                  }, null, 8, ["errors", "hasError"]),
                  _createVNode("p", null, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t('removing_user')) + ":", 1)
                  ]),
                  _createVNode("div", _hoisted_726, [
                    _createVNode("ul", null, [
                      _createVNode("li", null, _toDisplayString(_ctx.state.selectedShareInvitationForRemoval.email) + " " + _toDisplayString(_ctx.$t('removal_warning')), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_727, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn secondary-btn to-upper",
                    onClick: _cache[108] || (_cache[108] = 
//@ts-ignore
(...args) => (_ctx.hideShareProjectRemove && _ctx.hideShareProjectRemove(...args)))
                  }, _toDisplayString(_ctx.$t('cancel')), 1),
                  _createVNode("button", {
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[109] || (_cache[109] = 
//@ts-ignore
(...args) => (_ctx.removeShareInvitation && _ctx.removeShareInvitation(...args)))
                  }, _toDisplayString(_ctx.state.postLoading.removeShareInvitation
                    ? _ctx.$t('removing')
                    : _ctx.$t('yes_remove_user')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_728, [
      _createVNode("div", _hoisted_729, [
        _createVNode("div", _hoisted_730, [
          _createVNode("div", _hoisted_731, [
            _createVNode("div", _hoisted_732, [
              _createVNode("h5", _hoisted_733, _toDisplayString(_ctx.$t('hide_channel')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[110] || (_cache[110] = 
//@ts-ignore
(...args) => (_ctx.hideChannelClose && _ctx.hideChannelClose(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_734
              ])
            ]),
            _createVNode("div", _hoisted_735, [
              _createVNode("div", _hoisted_736, _toDisplayString(_ctx.$t('hide_confirmation')), 1)
            ]),
            _createVNode("div", _hoisted_737, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[111] || (_cache[111] = 
//@ts-ignore
(...args) => (_ctx.channelHide && _ctx.channelHide(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.projectHide ? _ctx.$t('loading1') : _ctx.$t('yes')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[112] || (_cache[112] = 
//@ts-ignore
(...args) => (_ctx.hideChannelClose && _ctx.hideChannelClose(...args)))
              }, _toDisplayString(_ctx.$t('no')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_738, [
      _createVNode("div", _hoisted_739, [
        _createVNode("div", _hoisted_740, [
          _createVNode("div", _hoisted_741, [
            _createVNode("div", _hoisted_742, [
              _createVNode("h5", _hoisted_743, _toDisplayString(_ctx.$t('unhide_channel')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[113] || (_cache[113] = 
//@ts-ignore
(...args) => (_ctx.showChannelClose && _ctx.showChannelClose(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_744
              ])
            ]),
            _createVNode("div", _hoisted_745, [
              _createVNode("div", _hoisted_746, _toDisplayString(_ctx.$t('unhide_confirmation')), 1)
            ]),
            _createVNode("div", _hoisted_747, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[114] || (_cache[114] = 
//@ts-ignore
(...args) => (_ctx.channelShow && _ctx.channelShow(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.channelShow ? _ctx.$t('loading1') : _ctx.$t('yes')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[115] || (_cache[115] = 
//@ts-ignore
(...args) => (_ctx.showChannelClose && _ctx.showChannelClose(...args)))
              }, _toDisplayString(_ctx.$t('yes')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_748, [
      _createVNode("div", _hoisted_749, [
        _createVNode("div", _hoisted_750, [
          _createVNode("div", _hoisted_751, [
            _createVNode("div", _hoisted_752, [
              _createVNode("h5", _hoisted_753, _toDisplayString(_ctx.$t('pin_to_top')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[116] || (_cache[116] = 
//@ts-ignore
(...args) => (_ctx.addFavProjectClose && _ctx.addFavProjectClose(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_754
              ])
            ]),
            _createVNode("div", _hoisted_755, [
              _createVNode("div", _hoisted_756, _toDisplayString(_ctx.$t('pin_confirmation')), 1)
            ]),
            _createVNode("div", _hoisted_757, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[117] || (_cache[117] = 
//@ts-ignore
(...args) => (_ctx.projectFav && _ctx.projectFav(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.projectFav ? _ctx.$t('loading1') : _ctx.$t('yes')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn to-upper",
                "data-dismiss": "modal",
                onClick: _cache[118] || (_cache[118] = 
//@ts-ignore
(...args) => (_ctx.addFavProjectClose && _ctx.addFavProjectClose(...args)))
              }, _toDisplayString(_ctx.$t('no')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_758, [
      _createVNode("div", _hoisted_759, [
        _createVNode("div", _hoisted_760, [
          _createVNode("div", _hoisted_761, [
            _createVNode("div", _hoisted_762, [
              _createVNode("h5", _hoisted_763, _toDisplayString(_ctx.$t('unpin_project')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[119] || (_cache[119] = 
//@ts-ignore
(...args) => (_ctx.removeFavProjectClose && _ctx.removeFavProjectClose(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_764
              ])
            ]),
            _createVNode("div", _hoisted_765, [
              _createVNode("div", _hoisted_766, _toDisplayString(_ctx.$t('unpin_confirmation')), 1)
            ]),
            _createVNode("div", _hoisted_767, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[120] || (_cache[120] = 
//@ts-ignore
(...args) => (_ctx.projectFavRemove && _ctx.projectFavRemove(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.projectFavRemove ? _ctx.$t('loading1') : _ctx.$t('yes')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn to-upper",
                "data-dismiss": "modal",
                onClick: _cache[121] || (_cache[121] = 
//@ts-ignore
(...args) => (_ctx.removeFavProjectClose && _ctx.removeFavProjectClose(...args)))
              }, _toDisplayString(_ctx.$t('no')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_768, [
      _createVNode("div", _hoisted_769, [
        (_ctx.state.postLoading.inviteAllUsers)
          ? (_openBlock(), _createBlock("div", _hoisted_770, [
              _hoisted_771
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_772, [
          _createVNode("div", _hoisted_773, [
            _createVNode("div", _hoisted_774, [
              _createVNode("div", _hoisted_775, [
                _createVNode("h5", _hoisted_776, _toDisplayString(_ctx.$t('create_private_group')), 1),
                _createVNode("p", _hoisted_777, _toDisplayString(_ctx.$t('create_project_collaboration')), 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[122] || (_cache[122] = 
//@ts-ignore
(...args) => (_ctx.hidePrivateChannel && _ctx.hidePrivateChannel(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_778
              ])
            ]),
            _createVNode("div", _hoisted_779, [
              _createVNode("div", _hoisted_780, [
                _createVNode(_component_ErrorList, {
                  errors: _ctx.state.errorList,
                  hasError: _ctx.state.isErrorStatus
                }, null, 8, ["errors", "hasError"]),
                (!_ctx.state.data.invitationVerify.showStatus)
                  ? (_openBlock(), _createBlock("div", _hoisted_781, [
                      (_ctx.state.selectPrivateChannel)
                        ? (_openBlock(), _createBlock("div", _hoisted_782, [
                            _createVNode("label", _hoisted_783, _toDisplayString(_ctx.$t('invite_channel')), 1),
                            _createVNode("div", _hoisted_784, [
                              _createVNode("p", _hoisted_785, _toDisplayString(_ctx.state.selectPrivateChannel.name), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_786, [
                        _createVNode("label", _hoisted_787, _toDisplayString(_ctx.$t('create_channel_with_member')), 1),
                        _createVNode(_component_multiselect, {
                          modelValue: _ctx.selectedUsers,
                          "onUpdate:modelValue": _cache[123] || (_cache[123] = ($event: any) => (_ctx.selectedUsers = $event)),
                          options: _ctx.allUsers,
                          "close-on-select": "true",
                          "custom-label": _ctx.nameWithEmail,
                          "clear-on-select": true,
                          placeholder: _ctx.$t('search_and_select'),
                          label: "email",
                          "track-by": "email",
                          onSelect: _cache[124] || (_cache[124] = ($event: any) => (_ctx.selectToChangeUsers(_ctx.selectedUsers)))
                        }, null, 8, ["modelValue", "options", "custom-label", "placeholder"]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.users, (user, userIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "email-tag",
                            key: userIndex
                          }, [
                            _createVNode("p", _hoisted_788, [
                              _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.email) + ") ", 1),
                              _createVNode("a", {
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                              }, [
                                _hoisted_789
                              ], 8, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ]),
                      _createVNode("div", _hoisted_790, [
                        _createVNode("label", _hoisted_791, _toDisplayString(_ctx.$t('invite_with_email')), 1),
                        _createVNode("div", _hoisted_792, [
                          _withDirectives(_createVNode("input", {
                            "onUpdate:modelValue": _cache[125] || (_cache[125] = ($event: any) => (_ctx.state.inviteMember = $event)),
                            type: "email",
                            class: "form-control",
                            id: "exampleInputEmail1",
                            "aria-describedby": "emailHelp",
                            placeholder: _ctx.$t('email_instructions'),
                            onKeyup: _cache[126] || (_cache[126] = _withKeys(
//@ts-ignore
(...args) => (_ctx.changeInviteMember && _ctx.changeInviteMember(...args)), ["enter"]))
                          }, null, 40, ["placeholder"]), [
                            [_vModelText, _ctx.state.inviteMember]
                          ]),
                          _createVNode("button", {
                            class: "to-upper",
                            onClick: _cache[127] || (_cache[127] = 
//@ts-ignore
(...args) => (_ctx.changeInviteMember && _ctx.changeInviteMember(...args)))
                          }, [
                            _hoisted_793,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
                          ])
                        ])
                      ]),
                      (_ctx.state.inputError)
                        ? (_openBlock(), _createBlock("p", _hoisted_794, _toDisplayString(_ctx.$t('please_fill_field')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.state.duplicate)
                        ? (_openBlock(), _createBlock("p", _hoisted_795, _toDisplayString(_ctx.$t('email_already_used')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.state.invite.invites && _ctx.state.invite.invites.length)
                        ? (_openBlock(), _createBlock("div", _hoisted_796, [
                            _createVNode("table", _hoisted_797, [
                              _createVNode("thead", _hoisted_798, [
                                _createVNode("tr", null, [
                                  _createVNode("td", _hoisted_799, _toDisplayString(_ctx.$t('email')), 1),
                                  _createVNode("td", null, _toDisplayString(_ctx.$t('mobile_number')), 1),
                                  _createVNode("td", null, _toDisplayString(_ctx.$t('first_name')), 1),
                                  _createVNode("td", null, _toDisplayString(_ctx.$t('last_name')), 1),
                                  _createVNode("td", null, _toDisplayString(_ctx.$t('notify_by')), 1),
                                  _createVNode("td", null, _toDisplayString(_ctx.$t('action')), 1)
                                ])
                              ]),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.invites, (invite, inviteIndex) => {
                                return (_openBlock(), _createBlock("tbody", { key: inviteIndex }, [
                                  _createVNode("tr", null, [
                                    _createVNode("td", null, [
                                      _createVNode("div", _hoisted_800, [
                                        _withDirectives(_createVNode("input", {
                                          type: "email",
                                          class: "form-control",
                                          readonly: "",
                                          "onUpdate:modelValue": ($event: any) => (invite.email = $event)
                                        }, null, 8, ["onUpdate:modelValue"]), [
                                          [_vModelText, invite.email]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("div", _hoisted_801, [
                                        _createVNode("div", _hoisted_802, [
                                          _hoisted_803,
                                          _withDirectives(_createVNode("input", {
                                            type: "number",
                                            class: invite.phoneError ? 'form-control error-field' : 'form-control',
                                            placeholder: "mobile number only",
                                            "onUpdate:modelValue": ($event: any) => (invite.phone = $event)
                                          }, null, 10, ["onUpdate:modelValue"]), [
                                            [_vModelText, invite.phone]
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("div", _hoisted_804, [
                                        _withDirectives(_createVNode("input", {
                                          type: "text",
                                          class: invite.fNameError ? 'form-control error-field' : 'form-control',
                                          "onUpdate:modelValue": ($event: any) => (invite.first_name = $event)
                                        }, null, 10, ["onUpdate:modelValue"]), [
                                          [_vModelText, invite.first_name]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("div", _hoisted_805, [
                                        _withDirectives(_createVNode("input", {
                                          type: "text",
                                          class: invite.lNameError ? 'form-control error-field' : 'form-control',
                                          "onUpdate:modelValue": ($event: any) => (invite.last_name = $event)
                                        }, null, 10, ["onUpdate:modelValue"]), [
                                          [_vModelText, invite.last_name]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("div", _hoisted_806, [
                                        _createVNode("div", _hoisted_807, [
                                          _createVNode("div", _hoisted_808, [
                                            _withDirectives(_createVNode("input", {
                                              class: "form-check-input",
                                              type: "checkbox",
                                              id: "inlineCheckbox1",
                                              value: "true",
                                              disabled: invite.mailDisable,
                                              "onUpdate:modelValue": ($event: any) => (invite.mailNotification = $event)
                                            }, null, 8, ["disabled", "onUpdate:modelValue"]), [
                                              [_vModelCheckbox, invite.mailNotification]
                                            ]),
                                            _hoisted_809
                                          ]),
                                          _createVNode("div", _hoisted_810, [
                                            _withDirectives(_createVNode("input", {
                                              class: "form-check-input",
                                              type: "checkbox",
                                              id: "inlineCheckbox2",
                                              value: "true",
                                              "onUpdate:modelValue": ($event: any) => (invite.smsNotification = $event)
                                            }, null, 8, ["onUpdate:modelValue"]), [
                                              [_vModelCheckbox, invite.smsNotification]
                                            ]),
                                            _createVNode("label", _hoisted_811, _toDisplayString(_ctx.$t('sms')), 1)
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("a", {
                                        class: "btn btn-sm red-btn mt-1 to-upper",
                                        href: "javascript:void(0)",
                                        onClick: ($event: any) => (_ctx.removeSelectedUser(invite))
                                      }, [
                                        _hoisted_812,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                                      ], 8, ["onClick"])
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_813, [
              _createVNode("div", null, [
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn secondary-btn mr-2  to-upper",
                  onClick: _cache[128] || (_cache[128] = 
//@ts-ignore
(...args) => (_ctx.hidePrivateChannel && _ctx.hidePrivateChannel(...args)))
                }, _toDisplayString(_ctx.$t('cancel')), 1),
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn default-btn",
                  onClick: _cache[129] || (_cache[129] = 
//@ts-ignore
(...args) => (_ctx.createPrivateChannelGroup && _ctx.createPrivateChannelGroup(...args)))
                }, _toDisplayString(_ctx.$t('make_private_channel')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_814, [
      _createVNode("div", _hoisted_815, [
        _createVNode("div", _hoisted_816, [
          _createVNode("div", _hoisted_817, [
            _createVNode("div", _hoisted_818, [
              (_ctx.isEdit)
                ? (_openBlock(), _createBlock("h5", _hoisted_819, _toDisplayString(_ctx.$t('edit')) + " : " + _toDisplayString(_ctx.state.data.selectedProject.name), 1))
                : (_openBlock(), _createBlock("h5", _hoisted_820, _toDisplayString(_ctx.state.data.selectedProject.name), 1)),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[130] || (_cache[130] = 
//@ts-ignore
(...args) => (_ctx.hideRenameProjectModal && _ctx.hideRenameProjectModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_821
              ])
            ]),
            _createVNode("div", _hoisted_822, [
              _createVNode("div", _hoisted_823, [
                (!_ctx.isEdit && _ctx.isUserStatus)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[131] || (_cache[131] = 
//@ts-ignore
(...args) => (_ctx.checkEdit && _ctx.checkEdit(...args)))
                    }, [
                      _hoisted_824,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('edit_details')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isEdit)
                ? (_openBlock(), _createBlock("p", _hoisted_825, [
                    _createTextVNode(_toDisplayString(_ctx.$t('note')) + " " + _toDisplayString(_ctx.$t('fields_marked_with')) + " ", 1),
                    _hoisted_826,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('are_mandatory')), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.ui.successMessage && !_ctx.isEdit)
                ? (_openBlock(), _createBlock("div", _hoisted_827, _toDisplayString(_ctx.state.ui.successMessage), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.errors.errorList.saveEditProject,
                hasError: _ctx.state.ui.errors.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_828, [
                _createVNode("label", _hoisted_829, [
                  _createTextVNode(_toDisplayString(_ctx.$t('project_name')) + " ", 1),
                  (_ctx.isEdit)
                    ? (_openBlock(), _createBlock("span", _hoisted_830, "*"))
                    : _createCommentVNode("", true)
                ]),
                _withDirectives(_createVNode("input", {
                  type: "email",
                  class: "form-control",
                  id: "exampleInputEmail1",
                  "aria-describedby": "emailHelp",
                  placeholder: _ctx.$t('project_name_placeholder'),
                  "onUpdate:modelValue": _cache[132] || (_cache[132] = ($event: any) => (_ctx.state.data.selectedProjectEdit.projectName = $event)),
                  disabled: !_ctx.isEdit
                }, null, 8, ["placeholder", "disabled"]), [
                  [_vModelText, _ctx.state.data.selectedProjectEdit.projectName]
                ])
              ]),
              _createVNode("div", _hoisted_831, [
                _createVNode("label", _hoisted_832, [
                  _createTextVNode(_toDisplayString(_ctx.$t('project_description')) + " ", 1),
                  (_ctx.isEdit)
                    ? (_openBlock(), _createBlock("span", _hoisted_833, "*"))
                    : _createCommentVNode("", true)
                ]),
                _withDirectives(_createVNode("textarea", {
                  class: "form-control",
                  name: "",
                  id: "",
                  cols: "30",
                  rows: "5",
                  placeholder: _ctx.$t('project_description_placeholder'),
                  "onUpdate:modelValue": _cache[133] || (_cache[133] = ($event: any) => (_ctx.state.data.selectedProjectEdit.projectDescription = $event)),
                  disabled: !_ctx.isEdit
                }, null, 8, ["placeholder", "disabled"]), [
                  [_vModelText, _ctx.state.data.selectedProjectEdit.projectDescription]
                ])
              ]),
              _createVNode("div", _hoisted_834, [
                _createVNode("label", _hoisted_835, _toDisplayString(_ctx.$t('project_tags')), 1),
                _createVNode(_component_multiselect, {
                  modelValue: _ctx.selectedOptions,
                  "onUpdate:modelValue": _cache[134] || (_cache[134] = ($event: any) => (_ctx.selectedOptions = $event)),
                  "tag-placeholder": "Add this as new tag",
                  placeholder: _ctx.$t('project_tags_placeholder'),
                  label: "name",
                  "track-by": "code",
                  options: _ctx.options,
                  multiple: true,
                  taggable: true,
                  onTag: _ctx.addTag,
                  disabled: !_ctx.isEdit
                }, null, 8, ["modelValue", "placeholder", "options", "onTag", "disabled"])
              ]),
              _createVNode("div", _hoisted_836, [
                _createVNode("label", _hoisted_837, _toDisplayString(_ctx.$t('project_address')), 1),
                _createVNode(_component_GoogleMapView, {
                  latitude: _ctx.latitude,
                  longitude: _ctx.longitude,
                  address: _ctx.address,
                  isEdit: _ctx.isEdit,
                  "onUpdate:latitude": _ctx.updateLatitude,
                  "onUpdate:longitude": _ctx.updateLongitude,
                  "onUpdate:address": _ctx.updateAddress,
                  key: _ctx.latitude
                }, null, 8, ["latitude", "longitude", "address", "isEdit", "onUpdate:latitude", "onUpdate:longitude", "onUpdate:address"])
              ])
            ]),
            _createVNode("div", _hoisted_838, [
              (_ctx.isEdit)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[135] || (_cache[135] = 
//@ts-ignore
(...args) => (_ctx.saveEditProject && _ctx.saveEditProject(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.saveEditProject
                    ? _ctx.$t('loading1')
                    : _ctx.$t('save_changes')), 1))
                : _createCommentVNode("", true),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[136] || (_cache[136] = 
//@ts-ignore
(...args) => (_ctx.hideRenameProjectModal && _ctx.hideRenameProjectModal(...args)))
              }, _toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage,
          subTitleMessage: _ctx.state.data.subTitleMessage,
          isButton: _ctx.state.data.isChannelCreated
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_839, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn mr-2 mb-2",
                onClick: _cache[137] || (_cache[137] = ($event: any) => (_ctx.addMember(_ctx.state.data.currentChannel)))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t('continue_to_invite_members')) + " ", 1),
                _hoisted_840
              ])
            ])
          ]),
          _: 1
        }, 8, ["onClose", "showModal", "titleMessage", "subTitleMessage", "isButton"]))
      : _createCommentVNode("", true),
    (_ctx.state.ui.isActive.upgradeSubscription)
      ? (_openBlock(), _createBlock(_component_UpgradeSubscriptionModal, {
          key: 1,
          onCloseModal: _ctx.hideUpdateSubscriptionModal
        }, null, 8, ["onCloseModal"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showProjectImageUploadModal)
      ? (_openBlock(), _createBlock(_component_ProjectImageUploadModal, {
          key: 2,
          onClose: _ctx.closeProjectImageUploadModal,
          showModal: _ctx.state.data.showProjectImageUploadModal,
          project: _ctx.state.projectDetail
        }, null, 8, ["onClose", "showModal", "project"]))
      : _createCommentVNode("", true),
    (_ctx.state.ui.modal.showProjectAcknowledgementModal)
      ? (_openBlock(), _createBlock(_component_ProjectApprovalModal, {
          key: 3,
          showModal: _ctx.state.ui.modal.showProjectAcknowledgementModal,
          selectedProject: _ctx.state.projectDetail,
          onClose: _ctx.hideProjectAcknowledgementModal,
          onAcknowledgedData: _ctx.setAcknowledgedData
        }, null, 8, ["showModal", "selectedProject", "onClose", "onAcknowledgedData"]))
      : _createCommentVNode("", true),
    (_ctx.state.ui.modal.showEditProjectAcknowledgementModal)
      ? (_openBlock(), _createBlock(_component_ProjectApprovalModalEdit, {
          key: 4,
          showModal: _ctx.state.ui.modal.showEditProjectAcknowledgementModal,
          selectedProject: _ctx.state.projectDetail,
          onClose: _ctx.hideEditProjectAcknowledgementModal,
          onAcknowledgedData: _ctx.setAcknowledgedData
        }, null, 8, ["showModal", "selectedProject", "onClose", "onAcknowledgedData"]))
      : _createCommentVNode("", true)
  ]))
}